import React, { Fragment, useCallback, useEffect, useMemo, useRef, useState } from "react";
import clsx from 'clsx';
import { Button, Form } from "react-bootstrap";
import CommerciumLoaderHost from "src/utils/CommerciumLoaderHost";
import { PLATFORM_FIELD, PlatformDataType } from "src/interfaces/Platform.interface";
import { AttributeType, MORE_MAPPING_FORM_DATA, MoreFieldMappingItem, RECIPE_FORM_DATA, TITLE_DESCRIPTION, PRICE_TEMPLATE_FIELD, OPTION_TYPE, PRICE_ADJUSTMENT_TYPE } from "src/interfaces/Template.interface";
import { getPlatformFieldsAsync } from "src/redux/actions/productActions";
import {
  createMoreMappingAsync, createRecipeAsync, duplicateRecipeAsync, getPlatformChildFieldDataCategoriesAsync, getPlatformFieldDataAttributesAsync, getPlatformParentFieldDataCategoriesAsync,
  getShortCodeAsync, postFieldDataAttributesAsync, savePlatformTitleDescriptionTemplateAsync,
  getCategoryTemplateUsingTemplateIdAsync, getRecipesAsyncUsingRecipeId, getMoreMappingAsync, getMoreMappingByTemplateIdAsync,
  getTitleDescriptionTemplateByIdAsync,
  getImageTemplateMappingForPlatformAsync,
} from "src/redux/actions/templateAndPricingActions";
import { useAppDispatch, useAppSelector } from "src/redux/storeHooks";
import InputAttributes from "./InputAttributes";
import CopyToClipboard from "react-copy-to-clipboard";
import { prepareDescriptionValueForSave } from "src/utils/CustomEditor";
import {
  isDescriptionHtmlSource,
  limitDescriptionValue,
} from "src/utils/descriptionHtmlSource";
import DescriptionHtmlEditor from "./DescriptionHtmlEditor";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from 'axios';
import { loggedInAdminAccessToken, LANGUAGES_ENUM } from 'src/utils/constants';
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import InputAttributes2 from "./InputAttributes2";
import { toast } from "react-toastify";
import { Formik, FormikProps } from "formik";
import { getPlatformPriceAsync, savePlatformPriceAsync, getPriceTemplateByIdAsync } from "src/redux/actions/productPricingAction";
import SavedQuickListsPanel, {
  SavedQuickListItem,
  type ListingProfilePageSize,
} from "./SavedQuickListsPanel";
import { useUserHavingWriteAccess } from "src/utils/useUserHavingWriteAccess";
import Select from "react-select";
import RecipeRuleItem from "./RecipeRuleItem";
import useAppToast from "src/hooks/useAppToast";
import { getApiErrorMessage, isApiPayloadSuccess, useProgressiveLoadingMessage } from "src/marketConnect/helpers";
import { usePermission } from "src/hooks/usePermission";
import { fetchSourcePlatformAsync } from "src/redux/actions/platformActions";
import CategoryMappingEngine, { CategoryMappingChangeData } from './CategoryMappingEngine';
import { fetchPlatformLimitations } from 'src/utils/platformLimitations';
import { usePriceModifierFields, PriceRuleFormValue, generateDefaultPriceRules } from './hooks/usePriceModifierFields';
import { useListingProfileAiAutoMap } from './hooks/useListingProfileAiAutoMap';
import { useMiscMappingEditState } from './hooks/useMiscMappingEditState';
import { DynamicPriceModifierRule } from './DynamicPriceModifierRule';
import { hydrateQuickListFormForEdit } from './utils/quickListEditUtils';
import {
  areMiscSourceFieldsReady,
  fetchMiscTemplatesWithRetry,
} from './utils/miscMappingHydrate';
import { executeQuickListUpdate } from './utils/quickListUpdateUtils';
import {
  applyPriceRuleMappingOptionChange,
  mapPriceTemplateToQuickListForm,
  shouldQueuePendingPriceHydrate,
} from './utils/quickListPriceHydrate';
import {
  resolvePriceRulesAfterTemplateHydrate,
  seedTemplatePriceRulesIfEmpty,
  shouldUseListingProfileTemplatePriceUi,
} from './utils/listingProfileTemplatePriceUi';
import {
  buildMoreMappingPayload,
  buildMoreMappingSaveEntries,
  buildOtherTemplateLinks,
  getMissingMandatoryMappingField,
  isMandatoryMoreMappingField,
  normalizeOptionalId,
  sanitizeClearedAttributeSelectValues,
  buildMoreMappingFormInitialValues,
} from '../utils/quicklistMoreMappingUtils';
import {
  formatLegacyRepricingMagnitudeForInput,
  resolveQuicklistPricePayload,
} from '../utils/quicklistPriceModifierUtils';
import {
  getPriceRuleValidationError,
  blockNegativeNumberInput,
  sanitizeNonNegativeNumericInput,
} from '../utils/priceModifierValidation';
import { LISTING_PROFILE_TOOLTIPS, SectionHeaderLabel } from './SectionHeaderInfoTooltip';
import ListingProfileSectionAccordion, { ProfileSectionAiAutoMapButton } from './ListingProfileSectionAccordion';
import {
  buildProfileIdentitySummary,
  buildProductCriteriaSummary,
  buildPriceModifierSummary,
  buildCategorySummary,
  buildMoreMappingsSectionSummary,
  indexToSectionLetter,
} from './utils/listingProfileAccordionUtils';
import {
  isListingProfileSaveBlockedByLoading,
  LISTING_PROFILE_SAVE_LOADING_MESSAGE,
} from './utils/listingProfileSaveReadiness';
import {
  isListingProfileBodyLoading,
  LISTING_PROFILE_BODY_LOADING_MESSAGE,
} from './utils/listingProfileBodyLoading';
import CommerciumLoader from 'src/utils/CommerciumLoader';
import {
  CATEGORY_ATTRIBUTE_CATALOG_UNAVAILABLE_MESSAGE,
  REQUIRED_CATEGORY_ATTRIBUTES_SAVE_MESSAGE,
  validateRequiredCategoryAttributesBeforeSave,
  type CategoryAttributeDefinition,
} from './utils/categoryAttributeIdentity';
import {
  isCreateListingProfileAwaitingTargetChannel,
  isListingProfileSectionBlockedWithoutTargetChannel,
  LISTING_PROFILE_PROFILE_SECTION_KEY,
  LISTING_PROFILE_LOCKED_SECTION_SUMMARY,
} from './utils/listingProfileTargetChannelGate';
import ListingProfileTargetChannelSelect from './ListingProfileTargetChannelSelect';
import ListingProfileToolbarChannelBadge from './ListingProfileToolbarChannelBadge';
import {
  isListingProfileFormDirty,
  ListingProfileViewModePayload,
  resolveListingProfileListPlatformId,
  resolvePlatformById,
} from './utils/listingProfileFormPlatformUtils';
import { getConnectedPlatformLabel } from '../utils/connectedPlatformLabel';
import ListingProfileImageMappingBlock, {
  ListingProfileImageMappingAddNew,
} from './ListingProfileImageMappingBlock';
import {
  applyImageMappingGetResponse,
  extractCreatedRecipeId,
  getMissingRequiredImageMappingSlotLabels,
  hasImageMappingUserInput,
  IMAGE_MAPPING_IS_DEFAULT_PAYLOAD_KEY,
  listImageMappingSlotsAvailableToAdd,
  type ImageMappingMeta,
  type ImageMappingRow,
} from '../utils/listingProfileImageMappingUtils';
import {
  deleteListingProfileImageMappingRow,
  persistListingProfileImageMapping,
} from '../utils/listingProfileImageMappingPersistence';

const LISTING_PROFILE_DEFAULT_TITLE = '[TITLE]';
const LISTING_PROFILE_DEFAULT_DESCRIPTION = '[DESCRIPTION]';

const applyListingProfileTitleDescriptionDefaults = (
  setTitle: (v: string) => void,
  setDescription: (v: string) => void
) => {
  setTitle(LISTING_PROFILE_DEFAULT_TITLE);
  setDescription(LISTING_PROFILE_DEFAULT_DESCRIPTION);
};

interface CreateQuickListTabProps {
  platformId: number | undefined;
  selectedSecondaryPlatform: PlatformDataType | null;
  currentActivePlatform: number | undefined;
  secondaryPlatforms: PlatformDataType[];
  isActiveTabInstance: boolean;
  onListingProfileViewModeChange?: (payload: ListingProfileViewModePayload) => void;
  listRefreshTrigger?: number;
  onRequestListingProfileListRefresh?: (platformId?: number) => void;
  /** Unified single list (no channel tabs). Legacy tabbed host uses `tabbed`. */
  listingHostMode?: 'unified' | 'tabbed';
}
type CategoryOption = {
  label: string
  value: string
}

type QuickListViewMode = 'list' | 'create' | 'edit';

const CreateQuickListTab: React.FC<CreateQuickListTabProps> = ({
  platformId,
  selectedSecondaryPlatform,
  currentActivePlatform,
  secondaryPlatforms,
  isActiveTabInstance,
  onListingProfileViewModeChange,
  listRefreshTrigger = 0,
  onRequestListingProfileListRefresh,
  listingHostMode = 'tabbed',
}) => {
  const isUnifiedListingHost = listingHostMode === 'unified';
  const dispatch = useAppDispatch();
  const categoryAttributeDefinitions = useAppSelector(
    (state) => state.templateAndPricing.getAttributeData
  );
  const categoryAttributeCatalogSnapshotRef = useRef<CategoryAttributeDefinition[]>([]);
  useEffect(() => {
    if (Array.isArray(categoryAttributeDefinitions) && categoryAttributeDefinitions.length > 0) {
      categoryAttributeCatalogSnapshotRef.current = categoryAttributeDefinitions;
    }
  }, [categoryAttributeDefinitions]);
  const [viewMode, setViewMode] = useState<QuickListViewMode>('list');
  const [formTargetPlatformId, setFormTargetPlatformId] = useState<number | null>(null);
  const [listChannelFilterPlatformId, setListChannelFilterPlatformId] = useState<number | null>(
    null
  );
  const [listPageSize, setListPageSize] = useState<ListingProfilePageSize>(10);
  const [expandedProfileSections, setExpandedProfileSections] = useState<Record<string, boolean>>({
    profile: true,
  });
  const [isTargetChannelFieldPulsing, setIsTargetChannelFieldPulsing] = useState(false);
  const [validationHighlightSection, setValidationHighlightSection] = useState<string | null>(
    null
  );
  const runtimePlatformId =
    viewMode === 'create'
      ? formTargetPlatformId ?? undefined
      : viewMode !== 'list'
        ? formTargetPlatformId ?? platformId ?? undefined
        : platformId;
  const activePlatform = useMemo(
    () => resolvePlatformById(runtimePlatformId ?? null, secondaryPlatforms, selectedSecondaryPlatform),
    [runtimePlatformId, secondaryPlatforms, selectedSecondaryPlatform]
  );
  const priceFieldsEnabled = isUnifiedListingHost
    ? viewMode !== 'list' && formTargetPlatformId != null
    : isActiveTabInstance &&
      (viewMode !== 'list' ? formTargetPlatformId != null : platformId === currentActivePlatform);
  const { isRead, isWrite, isDelete } = usePermission();
  const { mainStoreData, erpStoreData, omsStoreData, accountingStoreData, shippingStoreData, ticketStoreData, fetchedSourcePlatformData, fetchedConnectedPlatformData } = useAppSelector((state) => state.fetchConnectedPlatform) || {}
  const apiSource = fetchedSourcePlatformData?.source_platform
  const sourceStore = apiSource?.id
    ? apiSource
    : mainStoreData ?? omsStoreData ?? erpStoreData ?? accountingStoreData ?? shippingStoreData ?? null
  const { isUserHavingWriteAccess } = useUserHavingWriteAccess();
  const { warningToast, successToast } = useAppToast();
  const generateRandomRuleName = () => {
    const randomNum = Math.floor(100000 + Math.random() * 900000); // 6-digit random number
    return `QuickRule${randomNum}`;
  };
  const [ruleName, setRuleName] = useState('');
  const [status, setStatus] = useState<'ACTIVE' | 'DRAFT'>('ACTIVE');
  const finalRuleName = ruleName.trim() || generateRandomRuleName();
  const [isSaving, setIsSaving] = useState(false);
  const [resetTrigger, setResetTrigger] = useState(false);
  const [activeInsertionFieldId, setActiveInsertionFieldId] = useState<number | null>(null);
  const [customFieldDropdownFilter, setCustomFieldDropdownFilter] = useState<
    Record<string, string>
  >({});
  const [fieldDataRefreshKeys, setFieldDataRefreshKeys] = useState<Record<number, number>>({});
  // ── engine integration state ──
  const [engineState, setEngineState] = useState<CategoryMappingChangeData>({
    categoryId: null,
    categoryPath: '',
    isLeafCategory: false,
    showAttributes: false,
    isAttributeLoading: false,
  })
  const [engineKey, setEngineKey] = useState(0)
  const [preloadedAttributeCatalog, setPreloadedAttributeCatalog] = useState<AttributeType[]>([])
  const [platformLimitations, setPlatformLimitations] = useState<{
    title: { min: number | null; max: number | null; info: string | null }
    description: { min: number | null; max: number | null; info: string | null }
  }>({
    title: { min: null, max: null, info: null },
    description: { min: null, max: null, info: null },
  })

  const { priceTemplateFields, isLoading: priceFieldsLoading } = usePriceModifierFields({
    platformId: runtimePlatformId,
    enabled: priceFieldsEnabled,
  });


  // ── EDIT MODE STATE ──────────────────────────────────────────────────────────
  const [editingRecipeId, setEditingRecipeId] = useState<number | null>(null);
  const [editSubTemplateIds, setEditSubTemplateIds] = useState<{
    titleId: number | null;
    priceId: number | null;
    categoryId: number | null;
    moreMappingIds: { fieldId: number | null; templateId: number }[];
  }>({ titleId: null, priceId: null, categoryId: null, moreMappingIds: [] });

  // Lifted conditions state — feeds directly into Formik initialValues to avoid
  // duplicate rows caused by async setFieldValue racing with React re-renders.
  const defaultConditionRow = { id: null, checkConjunction: 'OR', checkOperator: 'CONTAINS', checkPlatformField: '', checkValue: '' };
  const [hydratedProductRecipes, setHydratedProductRecipes] = useState<any[]>([defaultConditionRow]);
  const [hydratedDataConjunction, setHydratedDataConjunction] = useState<string>('OR');
  const [editMappingDataDetails, setEditMappingDataDetails] = useState<any[]>([]);

  const [hydratingTitle, setHydratingTitle] = useState(false);
  const [hydratingImageMapping, setHydratingImageMapping] = useState(false);
  const [imageMappingMeta, setImageMappingMeta] = useState<ImageMappingMeta | null>(null);
  const [imageMappingRows, setImageMappingRows] = useState<ImageMappingRow[]>([]);
  const [imageTemplateMappingId, setImageTemplateMappingId] = useState<number | null>(null);
  const [imageMappingUnavailableMessage, setImageMappingUnavailableMessage] = useState<string | null>(
    null
  );
  const [imageMappingSectionVisible, setImageMappingSectionVisible] = useState(false);
  const [imageMappingShowIsDefault, setImageMappingShowIsDefault] = useState(false);
  const [imageMappingIsDefault, setImageMappingIsDefault] = useState(false);
  const [imageMappingIsDefaultPayloadKey, setImageMappingIsDefaultPayloadKey] = useState<
    'is_default' | 'isDefault'
  >(IMAGE_MAPPING_IS_DEFAULT_PAYLOAD_KEY);
  const imageMappingLoadSeqRef = useRef(0);
  const [hydratingPrice, setHydratingPrice] = useState(false);
  const [hydratingCategory, setHydratingCategory] = useState(false);
  const [sourceFieldListsLoadedFor, setSourceFieldListsLoadedFor] = useState<number | null>(null);
  const [sourcePlatformResolved, setSourcePlatformResolved] = useState(false);
  const shouldLoadFormPlatformData = isUnifiedListingHost
    ? viewMode !== 'list' && formTargetPlatformId != null
    : isActiveTabInstance &&
      (viewMode !== 'list' ? formTargetPlatformId != null : platformId === currentActivePlatform);
  const sourceFieldsReady = areMiscSourceFieldsReady({
    viewMode,
    editingRecipeId,
    sourceStoreId: sourceStore?.id ?? null,
    sourceFieldListsLoadedFor,
    sourcePlatformResolved,
    shouldLoadFormPlatformData,
  });
  const {
    moreFieldMappingData,
    showMoreMapping,
    miscSectionBusy,
    beginCatalogLoad,
    commitCatalog,
    abandonCatalogLoad,
    failedMiscTemplateRefs,
    prepareMiscEdit,
    acceptMiscTemplates,
    settleMiscTemplates,
    clearMiscEditMappings,
    setMiscAiOverlay,
  } = useMiscMappingEditState({
    viewMode,
    editingRecipeId,
    platformId: runtimePlatformId ?? null,
    sourceFieldsReady,
  });
  const pendingPriceHydrateRef = useRef<any>(null);
  const lastPriceHydratePayloadRef = useRef<any>(null);
  const priceHydrateAppliedFieldCountRef = useRef(0);
  const priceRulesTouchedRef = useRef(false);
  const priceMappingListsAppliedRef = useRef(0);
  const [priceHydrateVersion, setPriceHydrateVersion] = useState(0);
  const miscEditGenerationRef = useRef(0);
  const miscTemplateRetryingRef = useRef(false);
  const [miscTemplateRetrying, setMiscTemplateRetrying] = useState(false);

  const refreshListingProfileList = useCallback(
    (targetPlatformId?: number | null) => {
      if (isUnifiedListingHost) {
        onRequestListingProfileListRefresh?.();
        return;
      }
      const resolved = resolveListingProfileListPlatformId(
        targetPlatformId ?? formTargetPlatformId,
        platformId
      );
      if (resolved != null) {
        onRequestListingProfileListRefresh?.(resolved);
      }
    },
    [formTargetPlatformId, platformId, onRequestListingProfileListRefresh, isUnifiedListingHost]
  );

  const deriveAdjustmentType = (val: number | undefined | null): PRICE_ADJUSTMENT_TYPE => {
    if (val == null || val === 0) return "NO_CHANGE";
    return val > 0 ? "INCREASE" : "DECREASE";
  };

  const resetAll = () => {
    // Reset React states
    setTitleInput("");
    setEditorData("");
    setDescriptionHtmlSource(false);
    setStatus("ACTIVE");
    setPriceAdjustmentType("increase");
    setRepricing({ type: "FLAT", value: null });
    setPriceRules(priceTemplateFields.length > 0 ? generateDefaultPriceRules(priceTemplateFields) : []);
    setSelectedAttributes([]);
    setPreloadedAttributeCatalog([]);

    setOpenTitleAdvanceConfig(false);
    setTitleAdvanceSetting({
      isRemoveHtml: false,
      isTranslate: false,
      translate_language: "",
      isRephrasing: false,
      rephrasing_limit: "",
    });

    setCopyMarkup({});
    setButtonString("");

    setCategoryUpdateData(null);
    setInitialCategoryState({ categoryId: null, categoryPath: '', platformFieldId: null });

    // Drop saved miscellaneous templates for this edit. The channel field catalog
    // stays loaded so create mode still has its fields.
    clearMiscEditMappings();

    setEngineKey((prev) => prev + 1);
    setValidationHighlightSection(null);

    // Reset hydrated conditions back to the blank default row (used for Formik initialValues).
    // This ensures the Formik remount (triggered by editingRecipeId → null key change) starts clean.
    setHydratedProductRecipes([defaultConditionRow]);
    setHydratedDataConjunction('OR');
    setEditMappingDataDetails([]);
    setImageMappingMeta(null);
    setImageMappingRows([]);
    setImageTemplateMappingId(null);
    setImageMappingUnavailableMessage(null);
    setImageMappingSectionVisible(false);
    setImageMappingShowIsDefault(false);
    setImageMappingIsDefault(false);
    setImageMappingIsDefaultPayloadKey(IMAGE_MAPPING_IS_DEFAULT_PAYLOAD_KEY);
  };

  const exitEditMode = () => {
    const syncPlatformId = formTargetPlatformId ?? platformId ?? undefined;
    pendingPriceHydrateRef.current = null;
    lastPriceHydratePayloadRef.current = null;
    priceHydrateAppliedFieldCountRef.current = 0;
    priceRulesTouchedRef.current = false;
    priceMappingListsAppliedRef.current = 0;
    setEditingRecipeId(null);
    setEditSubTemplateIds({ titleId: null, priceId: null, categoryId: null, moreMappingIds: [] });
    setRuleName("");
    resetAll();
    setFormTargetPlatformId(null);
    setIsTargetChannelFieldPulsing(false);
    setViewMode('list');
    if (isActiveTabInstance) {
      onListingProfileViewModeChange?.({
        mode: 'list',
        ...(isUnifiedListingHost ? {} : { platformId: syncPlatformId }),
      });
    }
  };

  const hydrateFormForEdit = async (savedItem: SavedQuickListItem) => {
    pendingPriceHydrateRef.current = null;
    lastPriceHydratePayloadRef.current = null;
    priceHydrateAppliedFieldCountRef.current = 0;
    priceRulesTouchedRef.current = false;
    priceMappingListsAppliedRef.current = 0;
    setPreloadedAttributeCatalog([]);
    const editPlatformId = savedItem.platform ?? platformId ?? null;
    setFormTargetPlatformId(editPlatformId);
    const miscEditGeneration = prepareMiscEdit(editPlatformId ?? null, savedItem.id);
    miscEditGenerationRef.current = miscEditGeneration;
    try {
    await hydrateQuickListFormForEdit(savedItem, {
      platformId: editPlatformId ?? platformId,
      dispatch,
      checkFormField,
      priceTemplateFields,
      setEditingRecipeId,
      setRuleName,
      setStatus,
      setEditSubTemplateIds,
      // Conditions: lifted into state so Formik initialValues (keyed on editingRecipeId)
      // gets the correct rows on remount — avoids async setFieldValue duplication.
      setHydratedProductRecipes,
      setHydratedDataConjunction,
      setEditMappingDataDetails,
      setHydratingTitle,
      setTitleInput,
      setEditorData: (value: string) => {
        setDescriptionHtmlSource(isDescriptionHtmlSource(value));
        setEditorData(value);
      },
      setTagsInput,
      setSkuInput,
      setTitleAdvanceSetting,
      setDescriptionAdvanceSetting,
      setOpenTitleAdvanceConfig,
      setOpenDescriptionAdvanceConfig,
      setHydratingPrice,
      setPriceRules,
      setRepricing,
      setPriceAdjustmentType,
      setHydratingCategory,
      setCategoryUpdateData,
      setInitialCategoryState,
      setEngineState,
      setEngineKey,
      setSelectedAttributes,
      onMiscTemplatesLoaded: (loaded) => acceptMiscTemplates(miscEditGeneration, loaded),
      onPriceTemplateLoaded: (payload) => {
        lastPriceHydratePayloadRef.current = payload;
        if (
          shouldQueuePendingPriceHydrate(priceFieldsLoading, priceTemplateFields.length)
        ) {
          pendingPriceHydrateRef.current = payload;
          setPriceHydrateVersion((version) => version + 1);
        }
      },
    });
    setExpandedProfileSections({ profile: true });
    setViewMode('edit');
    if (isActiveTabInstance) {
      onListingProfileViewModeChange?.({
        mode: 'edit',
        ...(isUnifiedListingHost
          ? {}
          : { platformId: editPlatformId ?? platformId ?? undefined }),
      });
    }
    } finally {
      settleMiscTemplates(miscEditGeneration);
    }
  };

  const retryFailedMiscTemplates = useCallback(async () => {
    const generation = miscEditGenerationRef.current;
    const recipeId = editingRecipeId;
    const refs = failedMiscTemplateRefs;
    if (!generation || recipeId == null || refs.length === 0 || miscTemplateRetryingRef.current) return;
    miscTemplateRetryingRef.current = true;
    setMiscTemplateRetrying(true);
    try {
      const loaded = await fetchMiscTemplatesWithRetry(refs, async (templateId) => {
        const res: any = await dispatch(getMoreMappingByTemplateIdAsync({ templateId }));
        return res?.payload;
      });
      acceptMiscTemplates(generation, {
        recipeId: Number(recipeId),
        platformId: runtimePlatformId ?? null,
        templates: loaded.templates,
        failedRefs: loaded.failedRefs,
      });
    } finally {
      miscTemplateRetryingRef.current = false;
      setMiscTemplateRetrying(false);
    }
  }, [
    acceptMiscTemplates,
    dispatch,
    editingRecipeId,
    failedMiscTemplateRefs,
    runtimePlatformId,
  ]);

  const handleCopyCurrentEdit = async () => {
    if (!editingRecipeId) return;
    setIsSaving(true);
    try {
      const result: any = await dispatch(duplicateRecipeAsync({ recipeId: editingRecipeId }));
      if (result?.payload?.error || result?.error) {
        toast.error("Failed to copy Listing Profile.");
      } else {
        toast.success("Listing Profile copied successfully!");
        exitEditMode();
        refreshListingProfileList(platformId);
      }
    } catch (err) {
      toast.error("Unexpected error during copy.");
    } finally {
      setIsSaving(false);
    }
  };

  useEffect(() => {
    if (isUnifiedListingHost) return;
    if (platformId !== currentActivePlatform && viewMode !== 'list') {
      exitEditMode();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only reset when tab instance becomes inactive (legacy)
  }, [currentActivePlatform, platformId, isUnifiedListingHost]);

  // ---------------------------------------------------------------------------------------------------------------
  const [titleInput, setTitleInput] = useState('')
  const [editorData, setEditorData] = useState('')
  const [descriptionHtmlSource, setDescriptionHtmlSource] = useState(false)
  const [tagsInput, setTagsInput] = useState('')
  const [skuInput, setSkuInput] = useState('')
  const [showIsDefault, setShowIsDefault] = useState(false)
  const [shortCode, setShortCode] = useState<any[]>([])
  const [shortCodeVisibility, setShortCodeVisibility] = useState({
    name: false,
    title: false,
    tags: false,
    sku: false,
    description: false,
  })
  const [copyMarkup, setCopyMarkup] = useState<{ [key: string]: boolean }>({})
  const [buttonString, setButtonString] = useState('')
  const [titleAdvanceSetting, setTitleAdvanceSetting] = useState({
    isRemoveHtml: false,
    isTranslate: false,
    translate_language: '',
    isRephrasing: false,
    rephrasing_limit: '',
  })
  const [descriptionAdvanceSetting, setDescriptionAdvanceSetting] = useState({
    isRemoveHtml: false,
    isTranslate: false,
    translate_language: '',
    isRephrasing: false,
    rephrasing_limit: '',
  })
  const [openTitleAdvanceConfig, setOpenTitleAdvanceConfig] = useState(false)
  const [openDescriptionAdvanceConfig, setOpenDescriptionAdvanceConfig] = useState(false)
  const [categoryUpdateData, setCategoryUpdateData] = useState<any>(null);
  const [initialCategoryState, setInitialCategoryState] = useState<any>({ categoryId: null, categoryPath: '', platformFieldId: null });
  const { customFields, customHasMore, customLoading, customPage } = useSelector(
    (state: any) => state.customFieldsSlice || {}
  )
  const customItem = customFields?.length > 0

  const descriptionLimit = platformLimitations.description.max
  const remainingDescriptionCharacters =
    descriptionLimit && descriptionLimit > 0
      ? Math.max(descriptionLimit - editorData.length, 0)
      : 0

  // --- Handlers ---
  const handleDescriptionChange = (value: string, options?: { htmlSource?: boolean }) => {
    const htmlSource = options?.htmlSource ?? descriptionHtmlSource
    if (options?.htmlSource) {
      setDescriptionHtmlSource(true)
    }
    setEditorData(limitDescriptionValue(value, descriptionLimit, htmlSource))
  }

  const toggleShortCodeVisibility = (input: string) => {
    setShortCodeVisibility((prev) => ({ ...prev, [input]: !prev[input] }))
  }

  const handleCopyMarkup = (data: string, identifier: string) => {
    setCopyMarkup((prev) => ({ ...prev, [identifier]: true }))
    setButtonString(data)
    setTimeout(() => {
      setCopyMarkup((prev) => ({ ...prev, [identifier]: false }))
      setButtonString('')
    }, 1000)
  }

  const handleShortCode = async (input: string) => {
    try {
      const response = await dispatch(getShortCodeAsync({ shortcode_type: 'PRODUCT_SC', search_string: '' }))
      if (response.payload) {
        setShortCode(response.payload.results)
        toggleShortCodeVisibility(input)
      }
    } catch (err) {
      console.error('Error fetching shortcodes', err)
    }
  }

  const bumpFieldDataRefresh = (fieldId: number) => {
    setFieldDataRefreshKeys((prev) => ({
      ...prev,
      [fieldId]: (prev[fieldId] ?? 0) + 1,
    }))
  }

  const makeInsertionModalSetter =
    (fieldId: number) => (value: React.SetStateAction<boolean>) => {
      const isOpen =
        typeof value === 'function'
          ? value(activeInsertionFieldId === fieldId)
          : value
      setActiveInsertionFieldId(isOpen ? fieldId : null)
    }

  useEffect(() => {
    if (!shouldLoadFormPlatformData) return;
    let cancelled = false;
    setSourcePlatformResolved(false);
    Promise.resolve(dispatch(fetchSourcePlatformAsync())).finally(() => {
      if (!cancelled) setSourcePlatformResolved(true);
    });
    handleShortCode('description');
    handleShortCode('title');
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldLoadFormPlatformData, runtimePlatformId]);

  useEffect(() => {
    const loadPlatformLimitations = async () => {
      const platformCode = activePlatform?.platform_info?.name ?? activePlatform?.code;
      if (!platformCode) return;

      try {
        const next = await fetchPlatformLimitations(platformCode);
        setPlatformLimitations(next);
      } catch (error) {
        console.error('Failed to fetch platform limitations', error);
      }
    };

    if (
      viewMode !== 'list' ||
      isUnifiedListingHost ||
      platformId === currentActivePlatform
    ) {
      loadPlatformLimitations();
    }
  }, [activePlatform, viewMode, platformId, currentActivePlatform, isUnifiedListingHost]);

  useEffect(() => {
    if (viewMode === 'list' || !activePlatform?.id) {
      return;
    }
    if (viewMode === 'edit' && !editingRecipeId) {
      return;
    }

    let cancelled = false;
    const loadSeq = ++imageMappingLoadSeqRef.current;
    setHydratingImageMapping(true);

    dispatch(
      getImageTemplateMappingForPlatformAsync({
        platformId: activePlatform.id,
        templateMappingId: editingRecipeId ?? undefined,
      })
    )
      .then((res: any) => {
        if (cancelled || loadSeq !== imageMappingLoadSeqRef.current) return;
        const applied = applyImageMappingGetResponse(res.payload);
        setImageMappingMeta(applied.meta);
        setImageMappingRows(applied.rows);
        setImageTemplateMappingId(applied.imageTemplateMappingId);
        setImageMappingUnavailableMessage(applied.unavailableMessage);
        setImageMappingShowIsDefault(applied.showImageMappingIsDefault);
        setImageMappingIsDefault(applied.imageMappingIsDefault);
        setImageMappingIsDefaultPayloadKey(applied.imageMappingIsDefaultPayloadKey);
        setImageMappingSectionVisible(true);
      })
      .catch((err) => {
        if (cancelled || loadSeq !== imageMappingLoadSeqRef.current) return;
        console.error('Failed to load image mapping scaffold:', err);
        setImageMappingMeta(null);
        setImageMappingRows([]);
        setImageTemplateMappingId(null);
        setImageMappingUnavailableMessage('Failed to load image mapping for this channel.');
        setImageMappingShowIsDefault(false);
        setImageMappingIsDefault(false);
        setImageMappingIsDefaultPayloadKey(IMAGE_MAPPING_IS_DEFAULT_PAYLOAD_KEY);
        setImageMappingSectionVisible(true);
      })
      .finally(() => {
        if (!cancelled && loadSeq === imageMappingLoadSeqRef.current) {
          setHydratingImageMapping(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [activePlatform?.id, editingRecipeId, viewMode, dispatch]);

  const handleDeleteImageMappingRow = useCallback(
    async (row: ImageMappingRow): Promise<boolean> => {
      if (!activePlatform?.id) {
        warningToast('Select a target channel before removing image mappings.');
        return false;
      }
      const result = await deleteListingProfileImageMappingRow({
        dispatch,
        platformId: activePlatform.id,
        imageTemplateMappingId,
        row,
      });
      if (!result.ok) {
        warningToast(result.error ?? 'Failed to delete image mapping row');
        return false;
      }
      return true;
    },
    [activePlatform?.id, dispatch, imageTemplateMappingId, warningToast]
  );

  const renderCustomFieldDropdown = (sectionKey: string) => {
    if (!customFields?.length) return null;

    const handleDropdownToggle = (e: React.MouseEvent<HTMLDivElement>) => {
      e.stopPropagation();
      const menu = e.currentTarget.nextElementSibling as HTMLElement;
      const willOpen = menu.classList.contains('d-none');
      menu.classList.toggle('d-none');
      if (!willOpen) {
        setCustomFieldDropdownFilter((prev) => ({ ...prev, [sectionKey]: '' }));
      }
    };

    const handleItemClick = (
      e: React.MouseEvent<HTMLDivElement>,
      fieldName: string
    ) => {
      e.stopPropagation();
      navigator.clipboard.writeText(`[${fieldName}]`);
      handleCopyMarkup(fieldName, sectionKey);

      const menu = e.currentTarget.parentElement as HTMLElement;
      menu.classList.remove("d-none");
      setTimeout(() => menu.classList.add("d-none"), 1000);
    };

    const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
      const { scrollHeight, scrollTop, clientHeight } = e.currentTarget;
      const atBottom = scrollHeight - scrollTop <= clientHeight + 10;

      if (atBottom && customHasMore && !customLoading && sourceStore?.id) {
        dispatch(
          getPlatformFieldsAsync({
            platformId: sourceStore.id!,
            otherParams: {
              field_type: "CUSTOM",
              owner: "PRODUCT",
              includeLocalFields: false,
              limit: 100,
              page: customPage + 1,
            },
          })
        );
      }
    };

    const filterQuery = (customFieldDropdownFilter[sectionKey] ?? '').trim().toLowerCase();
    const visibleCustomFields = filterQuery
      ? customFields.filter((item) => {
          const display = String(item.display_name ?? '').toLowerCase();
          const api = String(item.api_name ?? '').toLowerCase();
          return display.includes(filterQuery) || api.includes(filterQuery);
        })
      : customFields;

    return (
      <div
        className="d-inline-block m-1 position-relative align-self-center"
        style={{ width: "130px" }}
      >
        {/* Dropdown Button */}
        <div
          className="rounded text-primary fs-sm-8 px-3 py-1 bg-white d-flex justify-content-between align-items-center m-1"
          style={{
            cursor: "pointer",
            userSelect: "none",
            border: "1px solid #1976d2",
            lineHeight: 1.5,
            minHeight: "calc(1.5em + 0.5rem + 2px)",
            boxSizing: "border-box",
          }}
          onClick={handleDropdownToggle}
        >
          CUSTOM_FIELDS
          <span className="text-primary ms-2">&#9662;</span>
        </div>

        {/* Dropdown Menu */}
        <div
          className="d-none position-absolute bg-white rounded  mt-1"
          style={{
            zIndex: 999,
            width: "130px",
            maxHeight: "170px",
            overflowY: "auto",
            border: "1px solid #1976d2",
          }}
          onClick={(e) => e.stopPropagation()}
          onScroll={handleScroll}
        >
          <div className="p-1 bg-white sticky-top" style={{ top: 0, zIndex: 1 }}>
            <input
              type="search"
              className="form-control form-control-sm"
              placeholder="Search"
              aria-label="Search custom fields"
              value={customFieldDropdownFilter[sectionKey] ?? ''}
              onChange={(e) => {
                e.stopPropagation();
                setCustomFieldDropdownFilter((prev) => ({
                  ...prev,
                  [sectionKey]: e.target.value,
                }));
              }}
              onClick={(e) => e.stopPropagation()}
              onKeyDown={(e) => e.stopPropagation()}
            />
          </div>
          {visibleCustomFields.length === 0 && !customLoading ? (
            <div className="text-center py-2 text-secondary small">No matches</div>
          ) : null}
          {visibleCustomFields.map((item) => {
            const isCopied =
              copyMarkup[sectionKey] && buttonString === item.display_name;
            return (
              <div
                key={item.id}
                onClick={(e) => handleItemClick(e, item.display_name)}
                className={`px-3 py-1 d-flex align-items-center justify-content-between fs-sm-8 ${isCopied
                  ? "bg-success text-white"
                  : "text-primary bg-white hover:"
                  }`}
                style={{
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  borderBottom: "1px solid #eee",
                  transition: "background-color 0.3s ease",
                }}
              >
                <span>{isCopied ? "Copied!" : `[${item.display_name}]`}</span>
                <FontAwesomeIcon
                  icon={faCopy}
                  color={isCopied ? "white" : "#1976d2"}
                  className="ms-2"
                  style={{ flexShrink: 0 }}
                />
              </div>
            );
          })}

          {customLoading && (
            <div className="text-center py-2 text-secondary small">
              Loading...
            </div>
          )}
        </div>
      </div>
    );
  };

  // ---------------------------------------------------------------------------------------------------------------
  // Price Logic State & Functions

  const [priceAdjustmentType, setPriceAdjustmentType] = useState<string>("decrease");
  const [repricing, setRepricing] = useState<{
    type: string;
    value: number | null;
    isDefault?: boolean;
    isDefaultPayloadKey?: 'is_default' | 'isDefault';
  }>({
    type: "FLAT",
    value: null,
  });
  const [priceRules, setPriceRules] = useState<PriceRuleFormValue[]>([]);
  const [priceNativeFields, setPriceNativeFields] = useState<PLATFORM_FIELD[]>([]);
  const [priceCustomFields, setPriceCustomFields] = useState<PLATFORM_FIELD[]>([]);
  const [priceMappingFieldsLoading, setPriceMappingFieldsLoading] = useState(false);
  const [priceMappingListsVersion, setPriceMappingListsVersion] = useState(0);

  useEffect(() => {
    if (!shouldLoadFormPlatformData || !sourceStore?.id) {
      setPriceNativeFields([]);
      setPriceCustomFields([]);
      return;
    }

    let cancelled = false;
    setPriceMappingFieldsLoading(true);

    const loadPriceMappingFields = async (fieldType: 'NATIVE' | 'CUSTOM') => {
      const response: any = await dispatch(
        getPlatformFieldsAsync({
          platformId: sourceStore.id!,
          otherParams: {
            field_type: fieldType,
            includeLocalFields: fieldType === 'NATIVE',
            owner: 'PRODUCT',
          },
        })
      );
      const payload = response?.payload;
      if (Array.isArray(payload)) return payload as PLATFORM_FIELD[];
      if (Array.isArray(payload?.results)) return payload.results as PLATFORM_FIELD[];
      return [];
    };

    Promise.all([loadPriceMappingFields('NATIVE'), loadPriceMappingFields('CUSTOM')])
      .then(([nativeFields, customFields]) => {
        if (cancelled) return;
        setPriceNativeFields(nativeFields);
        setPriceCustomFields(customFields);
        setPriceMappingListsVersion((version) => version + 1);
      })
      .catch((error) => {
        if (!cancelled) console.error('Error loading price mapping fields:', error);
      })
      .finally(() => {
        if (!cancelled) setPriceMappingFieldsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [shouldLoadFormPlatformData, sourceStore?.id, dispatch]);

  useEffect(() => {
    if (priceFieldsLoading) return;

    const deferredPayload = pendingPriceHydrateRef.current;
    const storedPayload = editingRecipeId ? lastPriceHydratePayloadRef.current : null;
    const hydratePayload = deferredPayload ?? storedPayload;
    const fieldsReady = priceTemplateFields.length > 0;
    const listsReadyForReapply =
      !priceMappingFieldsLoading &&
      priceMappingListsVersion > 0 &&
      priceMappingListsVersion !== priceMappingListsAppliedRef.current &&
      !priceRulesTouchedRef.current;

    const shouldApplyHydrate =
      hydratePayload && (fieldsReady || Boolean(deferredPayload));

    if (shouldApplyHydrate) {
      const mapped = mapPriceTemplateToQuickListForm(hydratePayload, priceTemplateFields, {
        nativeFields: priceNativeFields,
        customFields: priceCustomFields,
      });
      setRepricing({
        ...mapped.repricing,
        ...(mapped.templateIsDefault !== undefined && mapped.templateIsDefaultPayloadKey
          ? {
              isDefault: mapped.templateIsDefault,
              isDefaultPayloadKey: mapped.templateIsDefaultPayloadKey,
            }
          : {}),
      });
      setPriceAdjustmentType(mapped.adjustmentType);

      const fieldCount = priceTemplateFields.length;
      const shouldApplyRules =
        Boolean(deferredPayload) ||
        !priceHydrateAppliedFieldCountRef.current ||
        fieldCount > priceHydrateAppliedFieldCountRef.current ||
        listsReadyForReapply;

      if (mapped.rules.length > 0 && shouldApplyRules) {
        setPriceRules(mapped.rules);
        priceHydrateAppliedFieldCountRef.current = fieldCount;
        if (!priceMappingFieldsLoading && priceMappingListsVersion > 0) {
          priceMappingListsAppliedRef.current = priceMappingListsVersion;
        }
      } else if (shouldApplyRules) {
        setPriceRules(
          resolvePriceRulesAfterTemplateHydrate(
            mapped.rules,
            priceTemplateFields.length,
            () => generateDefaultPriceRules(priceTemplateFields)
          )
        );
        if (priceTemplateFields.length > 0) {
          priceHydrateAppliedFieldCountRef.current = fieldCount;
        }
      } else if (!editingRecipeId && mapped.rules.length === 0) {
        setPriceRules([]);
      }

      pendingPriceHydrateRef.current = null;
      return;
    }

    if (!priceFieldsLoading) {
      setPriceRules((current) =>
        seedTemplatePriceRulesIfEmpty(
          current,
          priceTemplateFields.length,
          priceRulesTouchedRef.current,
          () => generateDefaultPriceRules(priceTemplateFields)
        )
      );
      if (!editingRecipeId && priceTemplateFields.length === 0 && !priceRulesTouchedRef.current) {
        setPriceRules([]);
      }
    }
  }, [
    priceTemplateFields,
    editingRecipeId,
    priceHydrateVersion,
    priceFieldsLoading,
    priceNativeFields,
    priceCustomFields,
    priceMappingFieldsLoading,
    priceMappingListsVersion,
  ]);

  const handleMappingOptionChange = useCallback((rowIndex: number, option: OPTION_TYPE) => {
    priceRulesTouchedRef.current = true;
    setPriceRules((prev) => applyPriceRuleMappingOptionChange(prev, rowIndex, option));
  }, []);

  const handlePriceRuleChange = (index: number, field: keyof PriceRuleFormValue, value: any) => {
    priceRulesTouchedRef.current = true;
    setPriceRules(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      if (field === 'adjustmentType' && value === 'NO_CHANGE') {
        updated[index].adjustmentValue = '';
      }
      return updated;
    });
  };

  const handleAdjustmentChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const type = e.target.value;
    const magnitude =
      repricing.value != null && Number.isFinite(repricing.value)
        ? Math.abs(repricing.value)
        : null;
    const newValue =
      magnitude == null
        ? null
        : type === "decrease"
          ? -magnitude
          : magnitude;
    setRepricing({ ...repricing, value: newValue });
    setPriceAdjustmentType(type);
  };
  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const sanitized = sanitizeNonNegativeNumericInput(e.target.value);
    if (sanitized === '') {
      setRepricing({ ...repricing, value: null });
      return;
    }
    const val = Number(sanitized);
    if (!Number.isFinite(val)) return;
    setRepricing({
      ...repricing,
      value: priceAdjustmentType === "decrease" ? -Math.abs(val) : Math.abs(val),
    });
  };
  const handleTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setRepricing({ ...repricing, type: e.target.value });
  };
  // --------------------------------------------------------------------------------------------------------------------------
  // Category Section State & functions 
  const [isLeafCategory, setIsLeafCategory] = useState(false);
  const [showAttributes, setShowAttributes] = useState(false);
  const [selectedAttributes, setSelectedAttributes] = useState<any[]>([]);
  const [attributesInUpdateCase, setAttributesInUpdateCase] = useState(null);

  // ------------------------------------------------------------------------------
  // More Mapping filed Section
  useEffect(() => {
    if (!isUnifiedListingHost && !isActiveTabInstance) return;
    if (viewMode === 'list') {
      if (isUnifiedListingHost) return;
      if (platformId === currentActivePlatform && selectedSecondaryPlatform?.id) {
        callFieldMapping(selectedSecondaryPlatform);
      }
      return;
    }
    if (activePlatform?.id) {
      callFieldMapping(activePlatform);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentActivePlatform,
    viewMode,
    formTargetPlatformId,
    activePlatform?.id,
    isActiveTabInstance,
    isUnifiedListingHost,
  ]);

  const callFieldMapping = (item: PlatformDataType) => {
    if (!item.id) return;
    const requestId = beginCatalogLoad(item.id);
    setOtherTemplateFieldLoader(true);

    dispatch(
      getPlatformFieldsAsync({
        platformId: item.id,
        otherParams: { field_code: '', allowMapViaTemplate: true, owner: 'PRODUCT' },
      })
    ).then((response) => {
      const fields = Array.isArray(response?.payload) ? response.payload : [];
      const commitResult = commitCatalog(requestId, item.id!, fields);
      if (commitResult === 'stale') return;
      if (commitResult === 'applied') {
        setOtherTemplateFieldData(response.payload);
      }
      setOtherTemplateFieldLoader(false);
    }).catch(() => {
      abandonCatalogLoad(requestId);
      setOtherTemplateFieldLoader(false);
      toast.error('Error fetching mapping data');
    });
  };
  // ------------------------------------------------------------------------------------------------
  // Plan Section States and functionality
  const [templateDataLoading, setTemplateDataLoading] = useState(false)
  const [platformNativeFields, setPlatformNativeFields] = useState<PLATFORM_FIELD[] | []>([])
  const [platformCustomFields, setPlatformCustomFields] = useState<PLATFORM_FIELD[] | []>([])
  const [otherTemplateFieldLoader, setOtherTemplateFieldLoader] = useState(false);
  const [otherTemplateFieldData, setOtherTemplateFieldData] = useState([]);
  const [selectedRowsForDeletion, setSelectedRowsForDeletion] = useState<(number | null)[]>([]);

  const initialValue1: RECIPE_FORM_DATA = {
    name: '',
    selectedPricingTemplate: '',
    selectedTitleDescriptionTemplate: '',
    selectedCategoryTemplate: '',
    dataConjunction: hydratedDataConjunction,
    productRecipes: hydratedProductRecipes,
    other_templates: [],
  };

  const checkFormField = platformNativeFields[0]?.id + '';
  const isQuickTab = true;
  const formikRef = useRef<any>(null);
  const normalizePlatformFields = (payload: any): PLATFORM_FIELD[] => {
    if (Array.isArray(payload)) return payload
    if (Array.isArray(payload?.results)) return payload.results
    return []
  }

  useEffect(() => {
    if (!sourceStore?.id || !shouldLoadFormPlatformData) return;
    const storeId = sourceStore.id;
    let cancelled = false;
    setTemplateDataLoading(true);

    const fetchPlatformFields = async () => {
      try {
        // Fetch CUSTOM and NATIVE fields in parallel — both are independent requests.
        // Using Promise.all() halves the loader time compared to sequential awaits.
        const [customResponse, nativeResponse]: any[] = await Promise.all([
          dispatch(
            getPlatformFieldsAsync({
              platformId: sourceStore.id!,
              otherParams: {
                field_type: 'CUSTOM',
                owner: 'PRODUCT',
                includeLocalFields: false,
                limit: 100,
                page: 1,
              },
            })
          ),
          dispatch(
            getPlatformFieldsAsync({
              platformId: sourceStore.id!,
              otherParams: {
                field_type: 'NATIVE',
                owner: 'PRODUCT',
                includeLocalFields: true,
                limit: 100,
                page: 1,
              },
            })
          ),
        ]);

        if (cancelled) return;
        setPlatformCustomFields(normalizePlatformFields(customResponse?.payload));
        setPlatformNativeFields(normalizePlatformFields(nativeResponse?.payload));
      } catch (error) {
        if (!cancelled) console.error("Error fetching platform fields:", error);
      } finally {
        if (!cancelled) {
          setTemplateDataLoading(false);
          setSourceFieldListsLoadedFor(storeId);
        }
      }
    };

    fetchPlatformFields();

    return () => {
      cancelled = true;
    };

    // Call other mapping function removed as it is now handled by callFieldMapping
  }, [shouldLoadFormPlatformData, sourceStore?.id, runtimePlatformId]);

  const selectOptionFormat = (options) => {
    const format: CategoryOption[] = options.map((cat) => ({
      value: cat.id,
      label: cat.name,
    }))
    return format
  }

  // ------------------------------------------------------------------------------
  const resetForm = () => {
    // Basic text fields
    setRuleName("");
    setTitleInput("");
    setEditorData("");
    setDescriptionHtmlSource(false);
    setTagsInput("");
    setSkuInput("");
    setShowIsDefault(false);
    // Category dropdown logic
    setSelectedAttributes([]);
    setPreloadedAttributeCatalog([]);

    // Title advanced settings
    setTitleAdvanceSetting({
      isRemoveHtml: false,
      isTranslate: false,
      translate_language: "",
      isRephrasing: false,
      rephrasing_limit: "",
    });

    // Description advanced settings
    setDescriptionAdvanceSetting({
      isRemoveHtml: false,
      isTranslate: false,
      translate_language: "",
      isRephrasing: false,
      rephrasing_limit: "",
    });

    // Shortcodes panel
    setShortCodeVisibility({
      name: false,
      title: false,
      tags: false,
      sku: false,
      description: false,
    });

    // Pricing
    setPriceAdjustmentType("increase");
    setRepricing({ type: "FLAT", value: null });
    setPriceRules(priceTemplateFields.length > 0 ? generateDefaultPriceRules(priceTemplateFields) : []);

    setCategoryUpdateData(null);
    setInitialCategoryState({ categoryId: null, categoryPath: '', platformFieldId: null });

    // NOTE: Do NOT clear showMoreMapping / moreFieldMappingData here.
    // These are platform-scoped (set by callFieldMapping on mount/platform-change)
    // and must persist across form resets so the More Mapping sections remain visible.

    if (formikRef?.current) {
      formikRef.current.resetForm();
    }

    setEngineKey((prev) => prev + 1);
  };

  const createPayload = (): any => {
    return {
      platform_id: runtimePlatformId,
      name: finalRuleName,
      status: status,
      title_value_string: titleInput,
      description_value_string: prepareDescriptionValueForSave(editorData, {
        htmlSource: descriptionHtmlSource,
      }),
      tags_value_string: tagsInput,
      sku_value_string: skuInput,
      isDefault: showIsDefault,
      title_processing_config: {
        isRemoveHtml: titleAdvanceSetting.isRemoveHtml,
        isTranslate: titleAdvanceSetting.isTranslate,
        translate_language: titleAdvanceSetting.translate_language,
        isRephrasing: titleAdvanceSetting.isRephrasing,
        rephrasing_limit: titleAdvanceSetting.rephrasing_limit,
      },
      description_processing_config: {
        isRemoveHtml: descriptionAdvanceSetting.isRemoveHtml,
        isTranslate: descriptionAdvanceSetting.isTranslate,
        translate_language: descriptionAdvanceSetting.translate_language,
        isRephrasing: descriptionAdvanceSetting.isRephrasing,
        rephrasing_limit: descriptionAdvanceSetting.rephrasing_limit,
      },
    }
  };
  const formikMappingRefs = useRef<(FormikProps<MORE_MAPPING_FORM_DATA> | null)[]>([]);

  const {
    aiCategoryAutoMapLoading,
    aiMiscAutoMapLoading,
    moreMappingAiApplyVersion,
    handleCategoryAiAutoMap,
    handleMiscAiAutoMap,
    categoryAiAutoMapDisabled,
    miscAiAutoMapDisabled,
  } = useListingProfileAiAutoMap({
    formikRef,
    checkFormField,
    destinationPlatformId: activePlatform?.id ?? null,
    sourcePlatformId: sourceStore?.id ?? null,
    showMoreMapping,
    moreFieldMappingData,
    hydratingCategory,
    setHydratingCategory,
    setCategoryUpdateData,
    setInitialCategoryState,
    setEngineState,
    setEngineKey,
    setSelectedAttributes,
    setPreloadedAttributeCatalog,
    setMoreFieldMappingData: setMiscAiOverlay,
    successToast,
    warningToast,
  });

  const priceHydratePending =
    viewMode === 'edit' &&
    editSubTemplateIds.priceId != null &&
    pendingPriceHydrateRef.current != null;

  const isSaveBlockedByLoading = useMemo(
    () =>
      isListingProfileSaveBlockedByLoading({
        viewMode,
        hydratingTitle,
        hydratingPrice,
        hydratingCategory,
        hydratingImageMapping,
        miscSectionBusy,
        miscTemplateRetrying,
        aiCategoryAutoMapLoading,
        aiMiscAutoMapLoading,
        templateDataLoading,
        otherTemplateFieldLoader,
        priceFieldsLoading,
        priceMappingFieldsLoading,
        priceTemplateFieldCount: priceTemplateFields.length,
        isAttributeLoading: engineState.isAttributeLoading,
        priceHydratePending,
        editHasMiscLoadFailures: viewMode === 'edit' && failedMiscTemplateRefs.length > 0,
      }),
    [
      viewMode,
      hydratingTitle,
      hydratingPrice,
      hydratingCategory,
      hydratingImageMapping,
      miscSectionBusy,
      miscTemplateRetrying,
      aiCategoryAutoMapLoading,
      aiMiscAutoMapLoading,
      templateDataLoading,
      otherTemplateFieldLoader,
      priceFieldsLoading,
      priceMappingFieldsLoading,
      priceTemplateFields.length,
      engineState.isAttributeLoading,
      priceHydrateVersion,
      editSubTemplateIds.priceId,
      priceHydratePending,
      failedMiscTemplateRefs.length,
    ]
  );

  const isProfileBodyLoading = useMemo(
    () =>
      isListingProfileBodyLoading({
        viewMode,
        shouldLoadFormPlatformData,
        templateDataLoading,
        otherTemplateFieldLoader,
        sourcePlatformResolved,
        editingRecipeId,
        hydratingTitle,
        hydratingPrice,
        hydratingCategory,
        hydratingImageMapping,
        miscSectionBusy,
        priceHydratePending,
      }),
    [
      viewMode,
      shouldLoadFormPlatformData,
      templateDataLoading,
      otherTemplateFieldLoader,
      sourcePlatformResolved,
      editingRecipeId,
      hydratingTitle,
      hydratingPrice,
      hydratingCategory,
      hydratingImageMapping,
      miscSectionBusy,
      priceHydrateVersion,
      editSubTemplateIds.priceId,
      priceHydratePending,
    ]
  );

  const handleSubmit = (values) => {
  }

  const onSaveChanges = async () => {
    if (isSaveBlockedByLoading) {
      toast.info(LISTING_PROFILE_SAVE_LOADING_MESSAGE);
      return;
    }

    if (viewMode === 'create' && formTargetPlatformId == null) {
      pulseTargetChannelField();
      return;
    }

    const allValues: MORE_MAPPING_FORM_DATA[] = (moreFieldMappingData ?? [])
      .map((_, index) => {
        const values = formikMappingRefs.current[index]?.values ?? null
        return values ? sanitizeClearedAttributeSelectValues(values) : null
      })
      .filter((values): values is MORE_MAPPING_FORM_DATA => values != null);

    if (editingRecipeId !== null) {
      await executeQuickListUpdate({
        editingRecipeId,
        editSubTemplateIds,
        finalRuleName,
        status,
        platformId: runtimePlatformId,
        selectedSecondaryPlatform: activePlatform,
        formikRef,
        engineState,
        selectedAttributes,
        categoryAttributeDefinitions,
        categoryAttributeCatalogSnapshot: categoryAttributeCatalogSnapshotRef.current,
        titleInput,
        editorData,
        descriptionHtmlSource,
        tagsInput,
        skuInput,
        showIsDefault,
        titleAdvanceSetting,
        descriptionAdvanceSetting,
        priceTemplateFields,
        priceRules,
        repricing,
        allValues,
        moreFieldMappingData,
        checkFormField,
        dispatch,
        toast,
        setIsSaving,
        exitEditMode,
        selectedRowsForDeletion,
        setSelectedRowsForDeletion,
        focusSaveValidationSection,
        clearSaveValidationHighlight,
        listRefreshPlatformId: resolveListingProfileListPlatformId(
          formTargetPlatformId,
          platformId
        ),
        requestListingProfileListRefresh: onRequestListingProfileListRefresh,
        listingRefreshAllChannels: isUnifiedListingHost,
        imageMappingMeta,
        imageMappingRows,
        imageTemplateMappingId,
        imageMappingShowIsDefault,
        imageMappingIsDefault,
        imageMappingIsDefaultPayloadKey,
      });
      return;
    }

    const formikValues = formikRef.current?.values;

    if (status === "ACTIVE") {
      const missingMandatoryField = getMissingMandatoryMappingField(
        allValues,
        moreFieldMappingData ?? []
      );
      if (missingMandatoryField) {
        focusSaveValidationSection('more-mappings');
        toast.error(
          `Please provide a mapping or default value for the required field: ${missingMandatoryField.display_name}`
        );
        return;
      }

      if (imageMappingMeta) {
        const missingImageSlots = getMissingRequiredImageMappingSlotLabels(
          imageMappingMeta,
          imageMappingRows
        );
        if (missingImageSlots.length > 0) {
          focusSaveValidationSection('title-description');
          toast.error(
            `Please complete required image mapping for: ${missingImageSlots.join(', ')}`
          );
          return;
        }
      }

      if (engineState.categoryId === null) {
        focusSaveValidationSection('category');
        toast.error("Please select a category to proceed");
        return;
      }

      const categoryAttributeValidation = validateRequiredCategoryAttributesBeforeSave({
        categoryId: engineState.categoryId,
        isAttributeLoading: engineState.isAttributeLoading,
        categoryAttributes: categoryAttributeDefinitions,
        categoryAttributeCatalogSnapshot: categoryAttributeCatalogSnapshotRef.current,
        selectedAttributes,
      });
      if (!categoryAttributeValidation.ok) {
        focusSaveValidationSection('category');
        toast.error(
          categoryAttributeValidation.reason === 'catalog_unavailable'
            ? CATEGORY_ATTRIBUTE_CATALOG_UNAVAILABLE_MESSAGE
            : REQUIRED_CATEGORY_ATTRIBUTES_SAVE_MESSAGE
        );
        return;
      }

      if (!formikValues) {
        focusSaveValidationSection('products');
        toast.error("Please fill Product Criteria Form");
        return;
      }

      const hasInvalidCondition = formikValues.productRecipes?.some(
        (item) => item?.checkValue == null || !String(item.checkValue).trim()
      );

      if (hasInvalidCondition) {
        focusSaveValidationSection('products');
        toast.error("Please Add Value for Condition Evaluator");
        setIsSaving(false);
        return; // STOP entire save flow
      }
    }

    if (priceTemplateFields.length > 0) {
      const priceRuleValidationError = getPriceRuleValidationError(priceRules);
      if (priceRuleValidationError) {
        focusSaveValidationSection('price');
        toast.error(priceRuleValidationError);
        return;
      }
    }

    clearSaveValidationHighlight();
    const errors: string[] = [];
    setIsSaving(true);

    try {
      // ==================  Prepare all API payloads ==================
      const templateDesPayload = createPayload();
      const resolvedPricePayload = resolveQuicklistPricePayload({
        priceTemplateFields,
        priceRules,
        repricing,
        ruleName: finalRuleName,
        platformId: runtimePlatformId,
      });
      const pricePayload = resolvedPricePayload
        ? Array.isArray(resolvedPricePayload)
          ? resolvedPricePayload.map((payload) => ({ ...payload, status }))
          : { ...resolvedPricePayload, status }
        : null;
      const categoryPayload = {
        platform_id: activePlatform?.id,
        isDefault: false,
        name: finalRuleName,
        status: status,
        category_data: engineState.categoryId,
        attributes: selectedAttributes,
      };
      const moreMappingSaveEntries = buildMoreMappingSaveEntries(
        allValues,
        moreFieldMappingData ?? []
      );
      const mappingPayloads = moreMappingSaveEntries.map((entry, i) => ({
        ...buildMoreMappingPayload(
          entry,
          finalRuleName,
          i,
          activePlatform?.id ?? runtimePlatformId ?? null
        ),
        status,
      }));

      // ================== Run first stage APIs simultaneously ==================
      const firstStageApis = [
        { name: "Title/Description", call: () => dispatch(savePlatformTitleDescriptionTemplateAsync(templateDesPayload)) },
        ...(pricePayload
          ? [{ name: "Price Modifier", call: () => dispatch(savePlatformPriceAsync(pricePayload)) }]
          : []),
        { name: "Category Mapping", call: () => dispatch(postFieldDataAttributesAsync(categoryPayload)) },
        ...mappingPayloads.map((mp, i) => ({
          name: `More Mapping #${i + 1}`,
          call: () => dispatch(createMoreMappingAsync(mp)),
        })),
      ];
      const firstStageResults = await Promise.allSettled(firstStageApis.map((api) => api.call()));

      // Collect IDs and errors
      const apiResponses: Record<string, any> = {}; // store payloads by name
      firstStageResults.forEach((result, i) => {
        const apiName = firstStageApis[i].name;
        if (result.status === "fulfilled") {
          const response = result.value;
          if (!isApiPayloadSuccess(response)) {
            errors.push(getApiErrorMessage(response, `${apiName} failed`));
            return;
          }
          const payload = (response as any)?.payload;
          apiResponses[apiName] = payload;
        } else {
          errors.push(getApiErrorMessage(result.reason, `${apiName} failed`));
        }
      });
      if (errors.length > 0) {
        const message = [...new Set(errors)][0] ?? "Save failed";
        toast.error(message);
        console.error("❌ Failed APIs:", errors);
        return;
      }

      // ==================  Prepare recipePayload using IDs from first stage ==================
      const priceRes = apiResponses["Price Modifier"];
      const priceTemplateId = pricePayload
        ? Array.isArray(priceRes)
          ? (priceRes[0]?.price_template?.id || priceRes[0]?.id)
          : priceRes?.id
        : null;

      const recipePayload = {
        platform: activePlatform?.id,
        name: finalRuleName,
        status: status,
        type: "QUICKLIST",
        title_description_template: apiResponses["Title/Description"]?.id,
        price_template: priceTemplateId ?? null,
        category_template: apiResponses["Category Mapping"]?.id,
        check_data_conjunction: formikValues?.dataConjunction ?? "OR",
        mapping_data: formikValues?.productRecipes
          ? formikValues.productRecipes.map((item, index) => ({
              check_platform_field: item?.checkPlatformField === "" ? checkFormField : item?.checkPlatformField,
              check_operator: item?.checkOperator ?? "CONTAINS",
              check_conjunction: item?.checkConjunction,
              check_value: item?.checkValue ?? "",
              mapping_id: apiResponses[`More Mapping #${index + 1}`]?.id ?? null,
            }))
          : [],
        other_templates: buildOtherTemplateLinks(
          moreMappingSaveEntries,
          mappingPayloads.map((_, index) => apiResponses[`More Mapping #${index + 1}`])
        ),
      };
      // ==================  Run recipePayload API ==================
      const recipeResult = await dispatch(createRecipeAsync(recipePayload));

      if (!isApiPayloadSuccess(recipeResult)) {
        toast.error(getApiErrorMessage(recipeResult, "Failed to save Listing Profile."));
        return;
      } else {
        const createdRecipeId = extractCreatedRecipeId((recipeResult as any)?.payload);
        if (
          createdRecipeId &&
          imageMappingMeta &&
          activePlatform?.id &&
          hasImageMappingUserInput(imageMappingRows, imageMappingMeta)
        ) {
          const imageSave = await persistListingProfileImageMapping({
            dispatch,
            destinationPlatformId: activePlatform.id,
            templateMappingId: createdRecipeId,
            ruleName: finalRuleName,
            imageTemplateMappingId: null,
            meta: imageMappingMeta,
            rows: imageMappingRows,
            includeIsDefault: imageMappingShowIsDefault,
            isDefault: imageMappingIsDefault,
            isDefaultPayloadKey: imageMappingIsDefaultPayloadKey,
          });
          if (!imageSave.ok) {
            toast.error(imageSave.error ?? 'Listing profile saved but image mapping failed.');
          }
        }

        toast.success("All data saved successfully!");
        toast.success("Rule Name is " + finalRuleName);
        resetForm();
        const syncPlatformId = resolveListingProfileListPlatformId(
          formTargetPlatformId,
          platformId
        );
        setFormTargetPlatformId(null);
        setListChannelFilterPlatformId(null);
        setViewMode('list');
        if (isActiveTabInstance) {
          onListingProfileViewModeChange?.({
            mode: 'list',
            ...(isUnifiedListingHost ? {} : { platformId: syncPlatformId }),
          });
        }
        if (isUnifiedListingHost) {
          onRequestListingProfileListRefresh?.();
        } else if (syncPlatformId != null) {
          onRequestListingProfileListRefresh?.(syncPlatformId);
        }
      }
    } catch (err) {
      console.error("Unexpected error:", err);
      toast.error("Unexpected error during save process.");
      setRuleName(finalRuleName + "-1");
    } finally {
      setIsSaving(false);
    }
  };


  const isSaveDisabled =
    (status === 'ACTIVE' && !titleInput.trim()) || isSaveBlockedByLoading;

  const profileSectionKeys = useMemo(() => {
    const keys = ['profile', 'products', 'titleDesc', 'price', 'category'];
    if (showMoreMapping || miscSectionBusy) {
      keys.push('more-mappings');
    }
    return keys;
  }, [showMoreMapping, miscSectionBusy]);

  const getProfileSectionLetter = (key: string) => {
    const idx = profileSectionKeys.indexOf(key);
    return idx >= 0 ? indexToSectionLetter(idx) : 'A';
  };

  const isProfileSectionExpanded = (key: string) => Boolean(expandedProfileSections[key]);

  const isSectionValidationHighlighted = (key: string) => validationHighlightSection === key;

  const isCreateAwaitingTargetChannel = isCreateListingProfileAwaitingTargetChannel(
    viewMode,
    formTargetPlatformId
  );

  const isSectionBlockedWithoutTargetChannel = useCallback(
    (sectionKey: string) =>
      isListingProfileSectionBlockedWithoutTargetChannel(
        viewMode,
        sectionKey,
        formTargetPlatformId
      ),
    [viewMode, formTargetPlatformId]
  );

  const pulseTargetChannelField = useCallback(() => {
    setExpandedProfileSections((prev) => ({ ...prev, [LISTING_PROFILE_PROFILE_SECTION_KEY]: true }));
    const restart = () => setIsTargetChannelFieldPulsing(true);
    if (isTargetChannelFieldPulsing) {
      setIsTargetChannelFieldPulsing(false);
      requestAnimationFrame(() => requestAnimationFrame(restart));
    } else {
      restart();
    }
    requestAnimationFrame(() => {
      document
        .getElementById('lp-target-channel-field')
        ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }, [isTargetChannelFieldPulsing]);

  const handleTargetChannelFieldPulseEnd = useCallback(
    (event: React.AnimationEvent<HTMLDivElement>) => {
      if (event.animationName !== 'lp-target-channel-field-pulse') return;
      setIsTargetChannelFieldPulsing(false);
    },
    []
  );

  const getTargetChannelGateAccordionProps = useCallback(
    (sectionKey: string) => {
      const toggleDisabled = isSectionBlockedWithoutTargetChannel(sectionKey);
      return {
        toggleDisabled,
        onToggleBlocked: pulseTargetChannelField,
      };
    },
    [pulseTargetChannelField, isSectionBlockedWithoutTargetChannel]
  );

  const isSectionExpandedForDisplay = useCallback(
    (sectionKey: string) =>
      Boolean(expandedProfileSections[sectionKey]) &&
      !isSectionBlockedWithoutTargetChannel(sectionKey),
    [expandedProfileSections, isSectionBlockedWithoutTargetChannel]
  );

  const focusSaveValidationSection = useCallback((sectionKey: string) => {
    setValidationHighlightSection(sectionKey);
    setExpandedProfileSections((prev) => ({ ...prev, [sectionKey]: true }));
    requestAnimationFrame(() => {
      document
        .getElementById(`lp-section-${sectionKey}`)
        ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }, []);

  const clearSaveValidationHighlight = useCallback(() => {
    setValidationHighlightSection(null);
  }, []);

  const toggleProfileSection = (key: string) => {
    if (isSectionBlockedWithoutTargetChannel(key)) {
      pulseTargetChannelField();
      return;
    }
    setExpandedProfileSections((prev) => ({ ...prev, [key]: !prev[key] }));
    setValidationHighlightSection((current) => (current === key ? null : current));
  };

  const goToNextProfileSection = (currentKey: string) => {
    const idx = profileSectionKeys.indexOf(currentKey);
    if (idx < 0 || idx >= profileSectionKeys.length - 1) return;
    const nextKey = profileSectionKeys[idx + 1];
    if (
      isCreateAwaitingTargetChannel &&
      (currentKey === LISTING_PROFILE_PROFILE_SECTION_KEY ||
        isSectionBlockedWithoutTargetChannel(nextKey))
    ) {
      pulseTargetChannelField();
      return;
    }
    setExpandedProfileSections((prev) => ({
      ...prev,
      [currentKey]: false,
      [nextKey]: true,
    }));
    requestAnimationFrame(() => {
      document.getElementById(`lp-section-${nextKey}`)?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  };

  const goToPreviousProfileSection = (currentKey: string) => {
    const idx = profileSectionKeys.indexOf(currentKey);
    if (idx <= 0) return;
    const prevKey = profileSectionKeys[idx - 1];
    setExpandedProfileSections((prev) => ({
      ...prev,
      [currentKey]: false,
      [prevKey]: true,
    }));
    requestAnimationFrame(() => {
      document.getElementById(`lp-section-${prevKey}`)?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  };

  const resetProfileAccordion = () => {
    setExpandedProfileSections({ profile: true });
    setValidationHighlightSection(null);
    setIsTargetChannelFieldPulsing(false);
  };

  const hasNextProfileSection = (key: string) => {
    const idx = profileSectionKeys.indexOf(key);
    return idx >= 0 && idx < profileSectionKeys.length - 1;
  };

  const hasPreviousProfileSection = (key: string) => {
    const idx = profileSectionKeys.indexOf(key);
    return idx > 0;
  };

  const profileSectionNavProps = (key: string) => ({
    showNextButton: hasNextProfileSection(key),
    onNext: () => goToNextProfileSection(key),
    showPreviousButton: hasPreviousProfileSection(key),
    onPrevious: () => goToPreviousProfileSection(key),
  });

  const handleFormTargetPlatformChange = (nextPlatformId: number) => {
    if (viewMode === 'edit') return;
    if (nextPlatformId === formTargetPlatformId) return;
    setFormTargetPlatformId(nextPlatformId);
    setIsTargetChannelFieldPulsing(false);
    setEditingRecipeId(null);
    resetAll();
    applyListingProfileTitleDescriptionDefaults(setTitleInput, setEditorData);
    resetProfileAccordion();
    const nextPlatform = resolvePlatformById(nextPlatformId, secondaryPlatforms, null);
    if (nextPlatform) {
      callFieldMapping(nextPlatform);
    }
  };

  const activeChannelLabel = activePlatform ? getConnectedPlatformLabel(activePlatform) : 'Channel';

  const profileFormActions = (
    <>
      <Button
        size="sm"
        variant="secondary"
        className="product-listing__toolbar-btn fw-semibold"
        onClick={exitEditMode}
        disabled={isSaving}
      >
        Discard Changes
      </Button>
      {isWrite ? (
        <Button
          size="sm"
          type="button"
          variant={viewMode === 'edit' ? 'primary' : 'success'}
          className="product-listing__toolbar-btn fw-semibold"
          disabled={isSaveDisabled || !isUserHavingWriteAccess() || isSaving}
          title={isSaveBlockedByLoading ? LISTING_PROFILE_SAVE_LOADING_MESSAGE : undefined}
          onClick={onSaveChanges}
        >
          {isSaving
            ? viewMode === 'edit'
              ? 'Updating...'
              : 'Saving...'
            : viewMode === 'edit'
              ? 'Update Profile'
              : 'Save Profile'}
        </Button>
      ) : null}
    </>
  );

  return (
    <div style={{ paddingTop: '5px' }}>
      {/* === LIST VIEW === */}
      {viewMode === 'list' && (
        <SavedQuickListsPanel
          listScope={isUnifiedListingHost ? 'unified' : 'perPlatform'}
          platformId={platformId}
          secondaryPlatforms={secondaryPlatforms}
          channelFilterPlatformId={listChannelFilterPlatformId}
          onChannelFilterChange={
            isUnifiedListingHost ? setListChannelFilterPlatformId : undefined
          }
          disableCreate={isUnifiedListingHost && secondaryPlatforms.length === 0}
          onEdit={hydrateFormForEdit}
          onCreateClick={() => {
            setEditingRecipeId(null);
            setRuleName("");
            resetAll();
            applyListingProfileTitleDescriptionDefaults(setTitleInput, setEditorData);
            resetProfileAccordion();
            setFormTargetPlatformId(null);
            setViewMode("create");
            if (isActiveTabInstance) {
              onListingProfileViewModeChange?.({
                mode: 'create',
                ...(isUnifiedListingHost
                  ? {}
                  : { platformId: platformId ?? undefined }),
              });
            }
          }}
          refreshTrigger={listRefreshTrigger}
          listPageSize={listPageSize}
          onListPageSizeChange={setListPageSize}
          onDeleteCurrentEdit={(deletedId) => {
            if (deletedId === editingRecipeId) {
              exitEditMode();
            }
          }}
        />
      )}

      {/* === CREATE / EDIT FORM VIEW === */}
      {viewMode !== 'list' && (
        <div className="product-listing__profile-form">
          <div className="product-listing__profile-form-toolbar">
            <div className="product-listing__profile-form-toolbar-title">
              {viewMode === 'create' && formTargetPlatformId == null ? (
                <span>Create Listing Profile for Selected Channel</span>
              ) : (
                <>
                  <span>
                    {viewMode === 'edit' ? 'Update Listing Profile for' : 'Create Listing Profile for'}
                  </span>
                  <ListingProfileToolbarChannelBadge platform={activePlatform} />
                </>
              )}
            </div>
            <div className="product-listing__profile-form-toolbar-actions">
              {viewMode === 'edit' && isWrite && isUserHavingWriteAccess() ? (
                <Button
                  size="sm"
                  variant="outline-primary"
                  className="product-listing__toolbar-btn fw-semibold"
                  disabled={isSaving}
                  onClick={handleCopyCurrentEdit}
                >
                  <FontAwesomeIcon icon={faCopy} className="me-1" />
                  Copy
                </Button>
              ) : null}
              <Button
                size="sm"
                variant="outline-primary"
                className="product-listing__toolbar-btn fw-semibold product-listing__profile-form-back-btn"
                onClick={exitEditMode}
                disabled={isSaving}
              >
                <i className="bi bi-arrow-left me-1" aria-hidden="true" />
                Back
              </Button>
              {profileFormActions}
            </div>
          </div>

          <div className="product-listing__profile-setup-shell">
            <div className="product-listing__profile-section-stack">
            <ListingProfileSectionAccordion
              sectionId="lp-section-profile"
              letter={getProfileSectionLetter('profile')}
              isExpanded={isProfileSectionExpanded('profile')}
              onToggle={() => toggleProfileSection('profile')}
              highlight
              validationHighlight={isSectionValidationHighlighted('profile')}
              title={
                <SectionHeaderLabel
                  title="Profile Configuration"
                  tooltip={LISTING_PROFILE_TOOLTIPS.profileName}
                  tooltipId="listing-profile-name-tooltip"
                  required
                  requiredBadgeStyle="pill"
                />
              }
              summaryLine={buildProfileIdentitySummary(ruleName, activeChannelLabel, status)}
              {...profileSectionNavProps('profile')}
            >
                <div className="product-listing__profile-name-status-row">
                  <div className="product-listing__profile-name-field">
                    <Form.Group className="mb-0">
                      <Form.Label className="fw-semibold mb-2">
                        <SectionHeaderLabel
                          title="Profile Name"
                          tooltip={LISTING_PROFILE_TOOLTIPS.profileName}
                          tooltipId="listing-profile-name-tooltip-inner"
                          required
                          requiredBadgeStyle="pill"
                        />
                      </Form.Label>
                      <Form.Control
                        type="text"
                        className="product-listing__profile-form-control"
                        placeholder="Enter Profile Name"
                        value={ruleName}
                        onChange={(e) => setRuleName(e.target.value)}
                      />
                      <Form.Text className="text-muted">
                        Leaving this empty will auto-generate a Profile Name.
                      </Form.Text>
                    </Form.Group>
                  </div>
                  <div className="product-listing__profile-channel-status-group">
                    <div
                      id="lp-target-channel-field"
                      className={clsx(
                        'product-listing__profile-target-channel-field',
                        isTargetChannelFieldPulsing &&
                          'product-listing__profile-target-channel-field--focus-pulse'
                      )}
                      onAnimationEnd={handleTargetChannelFieldPulseEnd}
                      aria-live="polite"
                    >
                      {isTargetChannelFieldPulsing ? (
                        <span className="visually-hidden">
                          Select a target channel to continue configuring this profile.
                        </span>
                      ) : null}
                      <Form.Label className="fw-semibold mb-2">
                        <SectionHeaderLabel
                          title="Target Channel"
                          tooltip="Choose which connected sales channel this listing profile applies to."
                          tooltipId="listing-profile-target-channel-tooltip"
                          required
                          requiredBadgeStyle="pill"
                        />
                      </Form.Label>
                      <ListingProfileTargetChannelSelect
                        platforms={secondaryPlatforms}
                        valuePlatformId={formTargetPlatformId}
                        onChange={handleFormTargetPlatformChange}
                        disabled={viewMode === 'edit'}
                      />
                    </div>
                    <div className="product-listing__profile-status">
                      <Form.Label className="fw-semibold mb-2">
                        <SectionHeaderLabel
                          title="Profile Status"
                          tooltip={LISTING_PROFILE_TOOLTIPS.profileStatus}
                          tooltipId="listing-profile-status-tooltip"
                        />
                      </Form.Label>
                      <div
                        className={`product-listing__profile-status-select-wrap ${
                          status === 'ACTIVE'
                            ? 'product-listing__profile-status-select-wrap--active'
                            : 'product-listing__profile-status-select-wrap--draft'
                        }`}
                      >
                        <Form.Select
                          className="product-listing__profile-form-control product-listing__profile-status-select"
                          value={status}
                          aria-label="Profile Status"
                          onChange={(e) => setStatus(e.target.value as 'ACTIVE' | 'DRAFT')}
                        >
                          <option value="DRAFT">Draft</option>
                          <option value="ACTIVE">Active</option>
                        </Form.Select>
                      </div>
                    </div>
                  </div>
                </div>
            </ListingProfileSectionAccordion>

            {isProfileBodyLoading ? (
              <div
                className="product-listing__profile-sections-loading"
                aria-busy="true"
                aria-live="polite"
              >
                <CommerciumLoader
                  variant="section"
                  layout="plain"
                  message={LISTING_PROFILE_BODY_LOADING_MESSAGE}
                />
              </div>
            ) : (<>
              <Formik<RECIPE_FORM_DATA>
                innerRef={formikRef}
                key={`conditions-form-${editingRecipeId ?? 'create'}-${formTargetPlatformId ?? platformId ?? 'none'}`}
                initialValues={initialValue1}
                onSubmit={(values, helpers) => { }}
              >
                {({
                  values,
                  handleChange,
                  handleSubmit,
                  setFormikState,
                  setSubmitting,
                  setFieldValue,
                }) => (
                  <ListingProfileSectionAccordion
                    sectionId="lp-section-products"
                    letter={getProfileSectionLetter('products')}
                    isExpanded={isSectionExpandedForDisplay('products')}
                    onToggle={() => toggleProfileSection('products')}
                    {...getTargetChannelGateAccordionProps('products')}
                    validationHighlight={isSectionValidationHighlighted('products')}
                    title={
                      <SectionHeaderLabel
                        title="Which Products you want to list?"
                        tooltip={LISTING_PROFILE_TOOLTIPS.productCriteria}
                        tooltipId="listing-profile-product-criteria-tooltip"
                        required={status === 'ACTIVE'}
                        requiredBadgeStyle="pill"
                      />
                    }
                    summaryLine={
                      isSectionBlockedWithoutTargetChannel('products')
                        ? LISTING_PROFILE_LOCKED_SECTION_SUMMARY
                        : buildProductCriteriaSummary(values, platformNativeFields)
                    }
                    footerLeading={
                      isWrite ? (
                        <button
                          type="button"
                          className="btn btn-link btn-sm text-primary fw-bold p-0 product-listing__profile-add-link-btn"
                          onClick={() =>
                            setFormikState((pre) => ({
                              ...pre,
                              values: {
                                ...pre.values,
                                dataConjunction: values?.dataConjunction,
                                productRecipes: [
                                  ...pre.values.productRecipes,
                                  {
                                    id: null,
                                    checkConjunction: 'OR',
                                    checkOperator: 'CONTAINS',
                                    checkPlatformField: platformNativeFields[0]?.id + '',
                                    checkValue: '',
                                  },
                                ],
                              },
                            }))
                          }
                        >
                          + Add New
                        </button>
                      ) : null
                    }
                    {...profileSectionNavProps('products')}
                  >
                  <form onSubmit={handleSubmit} className="product-listing__product-criteria">
                    <div>
                      <div className="row align-items-center mb-2 product-listing__product-criteria-header">
                        {values.productRecipes.length > 1 && (
                          <div className="col-6 col-sm-2">
                            <p className="form-label mb-0">Select Condition</p>
                          </div>
                        )}

                        <div className="col-6 col-sm-3">
                          <p className="form-label mb-0">Select Field To Filter</p>
                        </div>

                        <div className="col-12 col-lg-6">
                          <p className="form-label mb-0">Condition Evaluator</p>
                        </div>
                      </div>
                      <div>
                        {values.productRecipes.map((recipe, recipeIndex) => (
                          <RecipeRuleItem
                            key={'recipeitem' + recipeIndex}
                            formValues={values}
                            handleChange={handleChange}
                            customFieldLoading={false}
                            recipe={recipe}
                            recipeIndex={recipeIndex}
                            setFormikState={setFormikState}
                            setSubmitting={setSubmitting}
                            getLatestRecipesList={() => { }}
                            recipeData={null}
                            recipeDataInDetail={
                              editMappingDataDetails.length
                                ? editMappingDataDetails[recipeIndex]
                                : null
                            }
                            platformCustomFields={platformCustomFields}
                            platformNativeFields={platformNativeFields}
                            selectedRowsForDeletion={selectedRowsForDeletion}
                            setSelectedRowsForDeletion={setSelectedRowsForDeletion}
                            checkFormField={checkFormField}
                            isQuickTab={isQuickTab}
                            hideConditionOnSingleRow={true}
                          />
                        ))}
                      </div>
                    </div>
                  </form>
                  </ListingProfileSectionAccordion>
                )}
              </Formik>

            <ListingProfileSectionAccordion
              sectionId="lp-section-titleDesc"
              letter={getProfileSectionLetter('titleDesc')}
              isExpanded={isSectionExpandedForDisplay('titleDesc')}
              onToggle={() => toggleProfileSection('titleDesc')}
              {...getTargetChannelGateAccordionProps('titleDesc')}
              validationHighlight={isSectionValidationHighlighted('titleDesc')}
              title={
                <SectionHeaderLabel
                  title="Title, Description & Images Mapping"
                  tooltip={LISTING_PROFILE_TOOLTIPS.titleDescriptionSection}
                  tooltipId="listing-profile-title-description-tooltip"
                  required={status === 'ACTIVE'}
                  requiredBadgeStyle="pill"
                />
              }
              summaryLine={
                isSectionBlockedWithoutTargetChannel('titleDesc')
                  ? LISTING_PROFILE_LOCKED_SECTION_SUMMARY
                  : undefined
              }
              footerLeading={
                !hydratingTitle &&
                !hydratingImageMapping &&
                imageMappingSectionVisible &&
                imageMappingMeta &&
                listImageMappingSlotsAvailableToAdd(imageMappingMeta, imageMappingRows).length > 0 ? (
                  <ListingProfileImageMappingAddNew
                    meta={imageMappingMeta}
                    rows={imageMappingRows}
                    onRowsChange={setImageMappingRows}
                  />
                ) : undefined
              }
              {...profileSectionNavProps('titleDesc')}
            >
                <div>
                  {hydratingTitle ? (
                    <CommerciumLoaderHost
                      variant="section"
                      layout="row"
                      compact
                      className="py-4"
                      label="Loading Title & Description rule data..."
                    />
                  ) : (<>
                  {/* ===== Title Section ===== */}
                  <div className="mb-4">
                    <div className="d-flex align-items-center justify-content-between" style={{ marginBottom: "6px" }}>
                      <label className="form-label mb-0">
                        <SectionHeaderLabel
                          title="Title"
                          tooltip={LISTING_PROFILE_TOOLTIPS.title}
                          tooltipId="listing-profile-title-tooltip"
                        />
                      </label>
                      {platformLimitations.title.info || platformLimitations.title.max ? (
                        <small className="text-muted text-end ms-3" style={{ maxWidth: '50%' }}>
                          {platformLimitations.title.info ??
                            `Recommended Max Character Limit: ${platformLimitations.title.max}`}
                          {platformLimitations.title.max
                            ? ` (${platformLimitations.title.max - titleInput.length} characters remaining)`
                            : ''}
                        </small>
                      ) : null}
                    </div>
                    <input
                      type="text"
                      className="form-control product-listing__title-field"
                      placeholder="Customize your Title."
                      onChange={(e) => {
                        const limit = platformLimitations.title.max
                        if (limit && limit > 0 && e.target.value.length > limit) return
                        setTitleInput(e.target.value)
                      }}
                      value={titleInput}
                      maxLength={platformLimitations.title.max ?? undefined}
                    />
                    {/* Shortcodes */}
                    <div className="mt-3">
                      <p className="small text-primary fw-bold mb-2">Available Shortcodes</p>
                      {shortCodeVisibility.title ? (
                        <div className="d-flex flex-wrap align-items-center">
                          {shortCode?.map((item: any) => (
                            <Fragment key={item.id}>
                              <CopyToClipboard text={item.name}>
                                <Button
                                  size="sm"
                                  variant={
                                    copyMarkup["title"] && buttonString === item.name
                                      ? "outline-success"
                                      : "outline-primary"
                                  }
                                  className={`px-3 py-1 border border-1 m-1 ${copyMarkup["title"] && buttonString === item.name
                                    ? "border-success"
                                    : "border-primary"
                                    } rounded text-hover-dark fs-sm-8`}
                                  onClick={() => handleCopyMarkup(item.name, "title")}
                                >
                                  {copyMarkup["title"] && buttonString === item.name ? (
                                    <span className="fs-sm-8">Copied!</span>
                                  ) : (
                                    item.name
                                  )}
                                </Button>
                              </CopyToClipboard>
                            </Fragment>
                          ))}
                          {customItem && renderCustomFieldDropdown("title")}
                        </div>
                      ) : (
                        <CommerciumLoaderHost variant="inline" layout="inline" className="ms-2" />
                      )}
                    </div>

                    {/* AI Optimization Toggle */}
                    <div className="mt-3">
                      <button
                        type="button"
                        className="btn btn-sm btn-link text-primary fw-bold p-0 d-inline-flex align-items-center gap-1"
                        onClick={() => setOpenTitleAdvanceConfig(!openTitleAdvanceConfig)}
                        aria-expanded={openTitleAdvanceConfig}
                      >
                        <i className="bi bi-sliders fw-bold text-primary"></i>
                        AI-Powered Content Optimization
                        <i
                          className={`bi product-listing__ai-optimization-caret ${openTitleAdvanceConfig ? 'bi-caret-down-fill' : 'bi-caret-right-fill'} ms-1`}
                          aria-hidden
                        />
                      </button>
                    </div>

                    {/* Title Advanced Settings */}
                    {openTitleAdvanceConfig && (
                      <div className="row mt-3">
                        <div className="col-3">
                          <div className="form-check form-switch d-flex align-items-center">
                            <label className="text-secondary fw-bold" htmlFor="titleCode">
                              Remove HTML
                            </label>
                            <input
                              id="titleCode"
                              className="form-check-input ms-2"
                              type="checkbox"
                              checked={titleAdvanceSetting.isRemoveHtml}
                              onChange={(ev) =>
                                setTitleAdvanceSetting((pre) => ({
                                  ...pre,
                                  isRemoveHtml: ev.target.checked,
                                }))
                              }
                            />
                          </div>
                        </div>

                        <div className="col-5">
                          <div className="form-check form-switch d-flex align-items-center">
                            <label className="text-secondary fw-bold" htmlFor="titleTranslate">
                              Translate To Other Language
                            </label>
                            <input
                              id="titleTranslate"
                              className="form-check-input ms-2"
                              type="checkbox"
                              checked={titleAdvanceSetting.isTranslate}
                              onChange={(ev) =>
                                setTitleAdvanceSetting((pre) => ({
                                  ...pre,
                                  isTranslate: ev.target.checked,
                                }))
                              }
                            />
                          </div>
                          {titleAdvanceSetting.isTranslate && (
                            <select
                              value={titleAdvanceSetting.translate_language}
                              className="form-select mt-2"
                              onChange={(ev) =>
                                setTitleAdvanceSetting((pre) => ({
                                  ...pre,
                                  translate_language: ev.target.value,
                                }))
                              }
                            >
                              <option value="">Select Language</option>
                              {LANGUAGES_ENUM.map((item) => (
                                <option key={"title" + item} value={item}>
                                  {item}
                                </option>
                              ))}
                            </select>
                          )}
                        </div>

                        <div className="col-4">
                          <div className="form-check form-switch d-flex align-items-center">
                            <label className="text-secondary fw-bold" htmlFor="titleRephrasing">
                              Rephrasing
                            </label>
                            <input
                              id="titleRephrasing"
                              className="form-check-input ms-2"
                              type="checkbox"
                              checked={titleAdvanceSetting.isRephrasing}
                              onChange={(ev) =>
                                setTitleAdvanceSetting((pre) => ({
                                  ...pre,
                                  isRephrasing: ev.target.checked,
                                }))
                              }
                            />
                          </div>
                          {titleAdvanceSetting.isRephrasing && (
                            <input
                              placeholder="Enter Character Limit"
                              type="number"
                              className="form-control mt-2"
                              value={titleAdvanceSetting.rephrasing_limit}
                              onChange={(ev) =>
                                setTitleAdvanceSetting((pre) => ({
                                  ...pre,
                                  rephrasing_limit: ev.target.value,
                                }))
                              }
                            />
                          )}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* ===== Description Section ===== */}
                  <div className="mb-3">
                    <div className="d-flex align-items-center justify-content-between" style={{ marginBottom: "6px" }}>
                      <label className="form-label mb-0">
                        <SectionHeaderLabel
                          title="Description"
                          tooltip={LISTING_PROFILE_TOOLTIPS.description}
                          tooltipId="listing-profile-description-tooltip"
                        />
                      </label>
                      {platformLimitations.description.info || platformLimitations.description.max ? (
                        <small className="text-muted text-end ms-3" style={{ maxWidth: '50%' }}>
                          {platformLimitations.description.info ??
                            `Recommended Max Character Limit: ${platformLimitations.description.max}`}
                          {platformLimitations.description.max
                            ? ` (${remainingDescriptionCharacters} characters remaining)`
                            : ''}
                        </small>
                      ) : null}
                    </div>
                    <DescriptionHtmlEditor
                      value={editorData}
                      onChange={handleDescriptionChange}
                      htmlSource={descriptionHtmlSource}
                      onHtmlSourceChange={setDescriptionHtmlSource}
                      maxCharacters={descriptionLimit}
                      placeholder="Customize your Description or map with Source Store field."
                    />
                  </div>
                  {/* Shortcodes */}
                  <div className="mt-3">
                    <p className="small text-primary fw-bold mb-2">Available Shortcodes</p>
                    {shortCodeVisibility.description ? (
                      <div className="d-flex flex-wrap align-items-center">
                        {shortCode?.map((item: any) => (
                          <Fragment key={item.id}>
                            <CopyToClipboard text={item.name}>
                              <Button
                                size="sm"
                                variant={
                                  copyMarkup["description"] && buttonString === item.name
                                    ? "outline-success"
                                    : "outline-primary"
                                }
                                className={`px-3 py-1 border border-1 m-1 ${copyMarkup["description"] && buttonString === item.name
                                  ? "border-success"
                                  : "border-primary"
                                  } rounded text-hover-dark fs-sm-8`}
                                onClick={() => handleCopyMarkup(item.name, "description")}
                              >
                                {copyMarkup["description"] && buttonString === item.name ? (
                                  <span className="fs-sm-8">Copied!</span>
                                ) : (
                                  item.name
                                )}
                              </Button>
                            </CopyToClipboard>
                          </Fragment>
                        ))}
                        {customItem && renderCustomFieldDropdown("description")}
                      </div>
                    ) : (
                      <CommerciumLoaderHost variant="inline" layout="inline" className="ms-2" />
                    )}
                  </div>

                  {/* AI Optimization Toggle */}
                  <div className="mt-3">
                    <button
                      type="button"
                      className="btn btn-sm btn-link text-primary fw-bold p-0 d-inline-flex align-items-center gap-1"
                      onClick={() => setOpenDescriptionAdvanceConfig(!openDescriptionAdvanceConfig)}
                      aria-expanded={openDescriptionAdvanceConfig}
                    >
                      <i className="bi bi-sliders fw-bold text-primary"></i>
                      AI-Powered Content Optimization
                      <i
                        className={`bi product-listing__ai-optimization-caret ${openDescriptionAdvanceConfig ? 'bi-caret-down-fill' : 'bi-caret-right-fill'} ms-1`}
                        aria-hidden
                      />
                    </button>
                  </div>

                  {/* Description Advanced Settings */}
                  {openDescriptionAdvanceConfig && (
                    <div className="row mt-3">
                      <div className="col-3">
                        <div className="form-check form-switch d-flex align-items-center">
                          <label className="text-secondary fw-bold" htmlFor="descCode">
                            Remove HTML
                          </label>
                          <input
                            id="descCode"
                            className="form-check-input ms-2"
                            type="checkbox"
                            checked={descriptionAdvanceSetting.isRemoveHtml}
                            onChange={(ev) =>
                              setDescriptionAdvanceSetting((pre) => ({
                                ...pre,
                                isRemoveHtml: ev.target.checked,
                              }))
                            }
                          />
                        </div>
                      </div>

                      <div className="col-5">
                        <div className="form-check form-switch d-flex align-items-center">
                          <label className="text-secondary fw-bold" htmlFor="descTranslate">
                            Translate To Other Language
                          </label>
                          <input
                            id="descTranslate"
                            className="form-check-input ms-2"
                            type="checkbox"
                            checked={descriptionAdvanceSetting.isTranslate}
                            onChange={(ev) =>
                              setDescriptionAdvanceSetting((pre) => ({
                                ...pre,
                                isTranslate: ev.target.checked,
                              }))
                            }
                          />
                        </div>
                        {descriptionAdvanceSetting.isTranslate && (
                          <select
                            value={descriptionAdvanceSetting.translate_language}
                            className="form-select mt-2"
                            onChange={(ev) =>
                              setDescriptionAdvanceSetting((pre) => ({
                                ...pre,
                                translate_language: ev.target.value,
                              }))
                            }
                          >
                            <option value="">Select Language</option>
                            {LANGUAGES_ENUM.map((item) => (
                              <option key={"desc" + item} value={item}>
                                {item}
                              </option>
                            ))}
                          </select>
                        )}
                      </div>

                      <div className="col-4">
                        <div className="form-check form-switch d-flex align-items-center">
                          <label className="text-secondary fw-bold" htmlFor="descRephrasing">
                            Rephrasing
                          </label>
                          <input
                            id="descRephrasing"
                            className="form-check-input ms-2"
                            type="checkbox"
                            checked={descriptionAdvanceSetting.isRephrasing}
                            onChange={(ev) =>
                              setDescriptionAdvanceSetting((pre) => ({
                                ...pre,
                                isRephrasing: ev.target.checked,
                              }))
                            }
                          />
                        </div>
                        {descriptionAdvanceSetting.isRephrasing && (
                          <input
                            placeholder="Enter Character Limit"
                            type="number"
                            className="form-control mt-2"
                            value={descriptionAdvanceSetting.rephrasing_limit}
                            onChange={(ev) =>
                              setDescriptionAdvanceSetting((pre) => ({
                                ...pre,
                                rephrasing_limit: ev.target.value,
                              }))
                            }
                          />
                        )}
                      </div>
                    </div>
                  )}
                  <ListingProfileImageMappingBlock
                    loading={hydratingImageMapping}
                    meta={imageMappingMeta}
                    rows={imageMappingRows}
                    onRowsChange={setImageMappingRows}
                    onDeleteRow={(row) => handleDeleteImageMappingRow(row)}
                    unavailableMessage={imageMappingUnavailableMessage}
                    showSection={imageMappingSectionVisible}
                    nativeFields={platformNativeFields}
                    customFields={platformCustomFields}
                    mappingFieldsLoading={templateDataLoading}
                    sourcePlatformId={sourceStore?.id}
                    showIsDefaultToggle={imageMappingShowIsDefault}
                    isDefault={imageMappingIsDefault}
                    onIsDefaultChange={setImageMappingIsDefault}
                  />
                  </>)}
                </div>
            </ListingProfileSectionAccordion>

            <ListingProfileSectionAccordion
              sectionId="lp-section-price"
              letter={getProfileSectionLetter('price')}
              isExpanded={isSectionExpandedForDisplay('price')}
              onToggle={() => toggleProfileSection('price')}
              {...getTargetChannelGateAccordionProps('price')}
              validationHighlight={isSectionValidationHighlighted('price')}
              title={
                <SectionHeaderLabel
                  title="Price Modifier"
                  tooltip={LISTING_PROFILE_TOOLTIPS.priceModifier}
                  tooltipId="listing-profile-price-modifier-tooltip"
                />
              }
              summaryLine={
                isSectionBlockedWithoutTargetChannel('price')
                  ? LISTING_PROFILE_LOCKED_SECTION_SUMMARY
                  : buildPriceModifierSummary(priceRules, repricing, priceAdjustmentType)
              }
              {...profileSectionNavProps('price')}
            >
                <div>
                  {hydratingPrice ? (
                    <CommerciumLoaderHost
                      variant="section"
                      layout="row"
                      compact
                      className="py-4"
                      label="Loading Price rule data..."
                    />
                  ) : (
                  <DynamicPriceModifierRule
                    priceRules={priceRules}
                    isLoading={priceFieldsLoading}
                    onChange={handlePriceRuleChange}
                    advancedMode={true}
                    hasPriceDateRows={priceRules.some(rule => rule.isPriceDate)}
                    nativeFields={priceNativeFields}
                    customFields={priceCustomFields}
                    mappingFieldsLoading={priceMappingFieldsLoading}
                    onMappingOptionChange={handleMappingOptionChange}
                    searchableFieldSelect
                    sourcePlatformId={sourceStore?.id}
                    useTemplatePriceUi={shouldUseListingProfileTemplatePriceUi(
                      priceTemplateFields.length,
                      priceFieldsLoading
                    )}
                    fallbackUI={
                      <div className="product-listing__price-modifier-fallback">
                        <span className="form-label mb-0 product-listing__price-modifier-fallback-label">
                          Adjustment Type
                        </span>
                        <select
                          className="form-select product-listing__price-modifier-fallback-control"
                          value={priceAdjustmentType}
                          onChange={handleAdjustmentChange}
                        >
                          <option value="increase">Increase</option>
                          <option value="decrease">Decrease</option>
                        </select>
                        <span className="product-listing__price-modifier-fallback-by">
                          <span className="form-label mb-0">by</span>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter value"
                            min={0}
                            step="any"
                            onKeyDown={blockNegativeNumberInput}
                            value={formatLegacyRepricingMagnitudeForInput(repricing.value)}
                            onChange={handleValueChange}
                          />
                        </span>
                        <select
                          className="form-select product-listing__price-modifier-fallback-control"
                          value={repricing.type}
                          onChange={handleTypeChange}
                        >
                          <option value="FLAT">Flat Amount</option>
                          <option value="PERCENTAGE">Percent</option>
                        </select>
                      </div>
                    }
                  />
                  )}
                </div>
            </ListingProfileSectionAccordion>

            <ListingProfileSectionAccordion
              sectionId="lp-section-category"
              letter={getProfileSectionLetter('category')}
              isExpanded={isSectionExpandedForDisplay('category')}
              onToggle={() => toggleProfileSection('category')}
              {...getTargetChannelGateAccordionProps('category')}
              validationHighlight={isSectionValidationHighlighted('category')}
              title={
                <SectionHeaderLabel
                  title="Category Mapping"
                  tooltip={LISTING_PROFILE_TOOLTIPS.category}
                  tooltipId="listing-profile-category-tooltip"
                  required={status === 'ACTIVE'}
                  requiredBadgeStyle="pill"
                />
              }
              summaryLine={
                isSectionBlockedWithoutTargetChannel('category')
                  ? LISTING_PROFILE_LOCKED_SECTION_SUMMARY
                  : buildCategorySummary(engineState.categoryPath)
              }
              headerTrailing={
                <ProfileSectionAiAutoMapButton
                  onClick={() => void handleCategoryAiAutoMap()}
                  loading={aiCategoryAutoMapLoading}
                  disabled={categoryAiAutoMapDisabled}
                  helpTooltip={LISTING_PROFILE_TOOLTIPS.aiAutoMapCategory}
                  helpTooltipId="listing-profile-category-ai-auto-map-tooltip"
                />
              }
              {...profileSectionNavProps('category')}
            >
                <div>
                  {hydratingCategory ? (
                    <CommerciumLoaderHost
                      variant="section"
                      layout="row"
                      compact
                      className="py-4"
                    />
                  ) : (
                  <CategoryMappingEngine
                    key={`engine-${engineKey}`}
                    appearance="listingProfile"
                    selectedSecondaryPlatform={activePlatform}
                    isEditMode={!!categoryUpdateData}
                    updatingMapData={categoryUpdateData}
                    initialCategoryId={initialCategoryState.categoryId}
                    initialCategoryPath={initialCategoryState.categoryPath}
                    initialPlatformFieldId={initialCategoryState.platformFieldId}
                    inputAttributesKey={String(engineState.categoryId)}
                    preloadedCategoryAttributes={preloadedAttributeCatalog}
                    onCategoryChange={setEngineState}
                    onAttributeSelection={(attributes) => setSelectedAttributes(attributes)}
                    nativeFields={platformNativeFields}
                    customFields={platformCustomFields}
                  />
                  )}
                </div>
            </ListingProfileSectionAccordion>

            {showMoreMapping || miscSectionBusy || failedMiscTemplateRefs.length > 0 ? (
              <ListingProfileSectionAccordion
                sectionId="lp-section-more-mappings"
                letter={getProfileSectionLetter('more-mappings')}
                isExpanded={isSectionExpandedForDisplay('more-mappings')}
                onToggle={() => toggleProfileSection('more-mappings')}
                {...getTargetChannelGateAccordionProps('more-mappings')}
                validationHighlight={isSectionValidationHighlighted('more-mappings')}
                title={
                  <SectionHeaderLabel
                    title="Miscellaneous Attribute Mappings"
                    tooltip="Map remaining marketplace attributes and fields for this listing profile."
                    tooltipId="listing-profile-more-mappings-tooltip"
                  />
                }
                summaryLine={
                  isSectionBlockedWithoutTargetChannel('more-mappings')
                    ? LISTING_PROFILE_LOCKED_SECTION_SUMMARY
                    : miscSectionBusy
                      ? 'Loading mappings…'
                      : buildMoreMappingsSectionSummary(moreFieldMappingData?.length ?? 0)
                }
                headerTrailing={
                  <ProfileSectionAiAutoMapButton
                    onClick={() => void handleMiscAiAutoMap()}
                    loading={aiMiscAutoMapLoading}
                    disabled={miscAiAutoMapDisabled}
                    helpTooltip={LISTING_PROFILE_TOOLTIPS.aiAutoMapMisc}
                    helpTooltipId="listing-profile-misc-ai-auto-map-tooltip"
                  />
                }
                {...profileSectionNavProps('more-mappings')}
              >
                {miscSectionBusy || aiMiscAutoMapLoading ? (
                  <CommerciumLoaderHost
                    variant="section"
                    layout="row"
                    compact
                    className="py-4"
                  />
                ) : (
                <div className="product-listing__more-mappings-grid">
                  {failedMiscTemplateRefs.length > 0 ? (
                    <div
                      className="d-flex align-items-center justify-content-between gap-3 mb-3"
                      role="alert"
                    >
                      <span className="text-danger">
                        Couldn't load {failedMiscTemplateRefs.length} saved mapping
                        {failedMiscTemplateRefs.length === 1 ? '' : 's'}
                      </span>
                      <button
                        type="button"
                        className="btn btn-sm btn-light"
                        onClick={() => void retryFailedMiscTemplates()}
                        disabled={miscTemplateRetrying}
                      >
                        Retry
                      </button>
                    </div>
                  ) : null}
                  <div className="product-listing__more-mappings-grid-header fw-semibold text-gray-600 mb-3">
                    <div>Attribute Name</div>
                    <div>Mapping Type</div>
                    <div className="product-listing__more-mappings-grid-header-value">
                      Attribute Value
                    </div>
                  </div>
                  {moreFieldMappingData?.map((item, index) => (
                    <div key={item.id} className="product-listing__more-mapping-field-block" data-field-id={item.id}>
                      <Formik<MORE_MAPPING_FORM_DATA>
                        key={`more-mapping-${item.id}-${item.moreMappingData?.id ?? 'new'}-ai${moreMappingAiApplyVersion}`}
                        innerRef={(el) => (formikMappingRefs.current[index] = el)}
                        enableReinitialize={true}
                        initialValues={buildMoreMappingFormInitialValues(
                          item,
                          item.moreMappingData,
                          runtimePlatformId
                        )}
                        onSubmit={handleSubmit}
                      >
                        {({ values, handleChange, setFieldValue, setFormikState }) => (
                          <Form>
                            <InputAttributes2
                              categoryAttributes={item}
                              paltformId={activePlatform?.id}
                              values={values}
                              handleChange={handleChange}
                              setFieldValue={setFieldValue}
                              setFormikState={setFormikState}
                              moreMappingData={item.moreMappingData || null}
                              getLatestMoreMappingDataList={() => console.log('refresh')}
                              resetTrigger={resetTrigger}
                              closeModal={() => bumpFieldDataRefresh(item.id)}
                              openAddNewAttributeValueModal={activeInsertionFieldId === item.id}
                              setOpenAddNewAttributeValueModal={makeInsertionModalSetter(item.id)}
                              insertionPayload={item?.insertion_payload}
                              fieldDataRefreshKey={fieldDataRefreshKeys[item.id] ?? 0}
                              nativeFields={platformNativeFields}
                              customFields={platformCustomFields}
                              listingProfileGridLayout
                              suppressColumnHeaders
                              fieldRequired={isMandatoryMoreMappingField(item)}
                              showAddNewValueButton={Boolean(item?.insertion_payload?.length)}
                              onAddNewValueClick={() => setActiveInsertionFieldId(item.id)}
                            />
                          </Form>
                        )}
                      </Formik>
                    </div>
                  ))}
                </div>
                )}
              </ListingProfileSectionAccordion>
            ) : null}
            </>)}
            </div>

            <div className="product-listing__profile-form-footer">
              {profileFormActions}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};


export default CreateQuickListTab;
